
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8xEcB", function(module, exports) {
$parcel$export(module.exports, "getPromptSummary", function () { return $b447011d95db7fc0$export$f16d3a1c7ad88615; });
$parcel$export(module.exports, "shouldShowInlinePreview", function () { return $b447011d95db7fc0$export$deba2b815ce92842; });
$parcel$export(module.exports, "InlinePreview", function () { return $b447011d95db7fc0$export$be2964ec75a6510e; });
/* inline-preview.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $ddxTX = parcelRequire("ddxTX");

var $iUVnd = parcelRequire("iUVnd");

var $9yC2v = parcelRequire("9yC2v");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $aBUAq = parcelRequire("aBUAq");

var $jUBSR = parcelRequire("jUBSR");

var $6qhMT = parcelRequire("6qhMT");
const $b447011d95db7fc0$var$inlinePreviewSectionCss = null;
const $b447011d95db7fc0$var$inlinePreviewContentCss = null;
const $b447011d95db7fc0$var$inlinePreviewStatusCss = null;
const $b447011d95db7fc0$var$inlinePreviewStatusLoadingBorderCss = null;
/* eslint-disable local/ensure-wac-token-usage */ const $b447011d95db7fc0$var$inlinePreviewStatusLoadingBorderLayerCss = null;
/* eslint-enable local/ensure-wac-token-usage */ const $b447011d95db7fc0$var$inlinePreviewSummaryTextCss = null;
const $b447011d95db7fc0$var$inlinePreviewSummaryRegularTextCss = null;
const $b447011d95db7fc0$var$inlinePreviewSummaryEmphasisTextCss = null;
const $b447011d95db7fc0$var$inlinePreviewWorkingTextCss = null;
const $b447011d95db7fc0$var$inlinePreviewErrorCss = null;
const $b447011d95db7fc0$var$tryAnotherPromptButtonStyles = {
    borderRadius: '40px',
    paddingLeft: '4px',
    paddingRight: '4px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    alignItems: 'center'
};
const $b447011d95db7fc0$var$signupLinkCss = null;
const $b447011d95db7fc0$export$f16d3a1c7ad88615 = ({ workingOnValue: workingOnValue, workingOnSuggestion: workingOnSuggestion, goalValue: goalValue, goalSuggestion: goalSuggestion })=>{
    const workingOn = (workingOnValue || workingOnSuggestion).trim();
    const goal = (goalValue || goalSuggestion).trim();
    if (!workingOn || !goal) return "I'm working on a new project with the goal of driving stronger outcomes.";
    return `I'm working on ${workingOn} with the goal of ${goal}...`;
};
const $b447011d95db7fc0$export$deba2b815ce92842 = ({ cgsDataLoading: cgsDataLoading, formattedCgsData: formattedCgsData })=>cgsDataLoading || Boolean(formattedCgsData?.length);
const $b447011d95db7fc0$export$be2964ec75a6510e = ({ cgsDataLoading: cgsDataLoading, isErrorFromCgs: isErrorFromCgs, hasSubmittedDefaultValues: hasSubmittedDefaultValues, promptSummary: promptSummary, formattedCgsData: formattedCgsData, spaceName: spaceName, onTryAnotherPrompt: onTryAnotherPrompt })=>{
    const { firePaidJiraAi: firePaidJiraAi } = (0, $jUBSR.useJiraAiFFL)();
    const hasFiredRevealStartedRef = (0, $1oC0p.useRef)(false);
    const hasFiredPreviewReadyRef = (0, $1oC0p.useRef)(false);
    const promptSummaryMatch = /^I'm working on (.+) with the goal of (.+)\.\.\.$/.exec(promptSummary);
    const localizedSignupHref = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-software&edition=free');
    const cgsKey = typeof window !== 'undefined' ? (0, $6qhMT.getCgsKeyFromLocationHref)(window.location.href) : undefined;
    const signupHref = cgsKey ? `${localizedSignupHref}&cgsKey=${encodeURIComponent(cgsKey)}` : localizedSignupHref;
    (0, $1oC0p.useEffect)(()=>{
        if (cgsDataLoading) {
            if (!hasFiredRevealStartedRef.current) {
                hasFiredRevealStartedRef.current = true;
                hasFiredPreviewReadyRef.current = false;
                firePaidJiraAi('PreviewRevealStarted', 'started', {
                    surface: 'inlinePreview'
                });
            }
            return;
        }
        if (formattedCgsData?.length && !hasFiredPreviewReadyRef.current) {
            hasFiredPreviewReadyRef.current = true;
            firePaidJiraAi('PreviewReady', 'succeeded', {
                surface: 'inlinePreview',
                rowCount: formattedCgsData.length
            });
        }
        if (!formattedCgsData?.length) {
            hasFiredRevealStartedRef.current = false;
            hasFiredPreviewReadyRef.current = false;
        }
    }, [
        cgsDataLoading,
        firePaidJiraAi,
        formattedCgsData
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1pfh1uc6 _6rth8vuz _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19121cl4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1pbykb7n"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb18a4 _p12f1osq _19pkidpf _2hwx1wug _otyr1f4h _18u01wug _11q71afi _2rko7vkz _16qshjmo _ca0qftgi _u5f3gktf _n3tdftgi _19bvgktf _1e0c1txw _4cvr1h6o _1bah1yb4 _gy1p7vkz",
                        cgsDataLoading && "_kqswh2mm _1reo15vq _18m915vq"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        cgsDataLoading && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                "aria-hidden": "true",
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _2rko1kw7 _1itk1oki _tzy415iw _31mtepuu _g3cmkvto _lcxvglyw"
                                ])
                            })
                        }),
                        cgsDataLoading ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1wybdlk8 _vwz4gktf _syaz1pfd _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                    ]),
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                    },
                                    children: promptSummaryMatch ? /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_k48p1nn1 _1dyznl7k"
                                                ]),
                                                children: "I'm working on"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_k48pni7l _1dyznl7k"
                                                ]),
                                                children: ' ' + promptSummaryMatch[1] + ' '
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_k48p1nn1 _1dyznl7k"
                                                ]),
                                                children: "with the goal of"
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_k48pni7l _1dyznl7k"
                                                ]),
                                                children: ' ' + promptSummaryMatch[2] + '...'
                                            })
                                        ]
                                    }) : promptSummary
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1wybdlk8 _vwz4gktf _syaz1pfd"
                                    ]),
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                    },
                                    children: "Working..."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1wybdlk8 _vwz4gktf _syaz1pfd _1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                                    ]),
                                    style: {
                                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                    },
                                    children: [
                                        "Your Jira space is ready.",
                                        ' ',
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                            href: signupHref,
                                            "data-event": "clicked",
                                            "data-event-container": "inlinePreview",
                                            "data-event-component": "signupLink",
                                            "data-product-key": "jiraSoftware-PaidLpJiraFflV3",
                                            onClick: ()=>{
                                                firePaidJiraAi('AccountCreationSubmitClicked', 'clicked', {
                                                    source: 'inlinePreview',
                                                    method: 'link'
                                                });
                                            },
                                            className: (0, $2jatx.default)([
                                                "_syazu5k9 _4bfu1r31 _1hms8stv _ajmmnqa1 _l7edyh40 _k48pni7l _30l3culw"
                                            ]),
                                            style: {
                                                "--_5dnsy5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue700')),
                                                "--_1hcckvk": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue900'))
                                            },
                                            children: "Sign up"
                                        }),
                                        ' ',
                                        "to save your progress and make it your own."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9yC2v))), {
                                        label: "Try another prompt"
                                    }),
                                    style: $b447011d95db7fc0$var$tryAnotherPromptButtonStyles,
                                    onClick: onTryAnotherPrompt,
                                    children: "Try another prompt"
                                })
                            ]
                        })
                    ]
                }),
                isErrorFromCgs && !hasSubmittedDefaultValues && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb18a4 _p12f1osq _19pkidpf _2hwx1wug _otyr7vkz _18u01wug _19it3dcd _bfhklnmr _1wybdlk8 _vwz410nf _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _syaz1pfd _1e0c1txw _zulp1j6v _4cvr1h6o _2rko1kwk"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUVnd))), {
                            label: "error",
                            color: "var(--ds-icon-warning, #E06C00)"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: "We couldn't build the project the way you asked for it. So we have built out a project that showcases what Rovo and Jira are capable of."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aBUAq.PreviewTable), {
                    rows: cgsDataLoading ? undefined : formattedCgsData,
                    spaceName: cgsDataLoading ? undefined : spaceName
                })
            ]
        })
    });
};

});
parcelRegister("9yC2v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79393cf52935af5d2ce7204817b33e1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f54cbdf12a460b8$var$_react = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f54cbdf12a460b8$var$_baseNew = $6f54cbdf12a460b8$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6f54cbdf12a460b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f54cbdf12a460b8$var$RandomizeIcon = (props)=>/*#__PURE__*/ $6f54cbdf12a460b8$var$_react.default.createElement($6f54cbdf12a460b8$var$_baseNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$6f54cbdf12a460b8$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $6f54cbdf12a460b8$var$_default = module.exports.default = $6f54cbdf12a460b8$var$RandomizeIcon;

});

parcelRegister("aBUAq", function(module, exports) {
$parcel$export(module.exports, "PreviewTable", function () { return $ac5d463a4909f1e1$export$17497d5d2ced1033; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $hSlTI = parcelRequire("hSlTI");
const $ac5d463a4909f1e1$var$TABLE_HEADERS = [
    'Work',
    'Status',
    'Due date',
    'Priority',
    'Assignee'
];
const $ac5d463a4909f1e1$var$tableContainerCss = null;
const $ac5d463a4909f1e1$var$tableCss = null;
const $ac5d463a4909f1e1$var$tableCellHeaderCss = null;
const $ac5d463a4909f1e1$export$17497d5d2ced1033 = ({ rows: rows })=>{
    const headerCells = $ac5d463a4909f1e1$var$TABLE_HEADERS.map((columnHeader)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
            className: (0, $2jatx.default)([
                "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                "_bfhkg7ng _k48p1fw0 _1wyb1yny _syaz1qc2 _1ezzlvwl _12ornqa1 _1r62t94y _y3gnv2br",
                columnHeader !== 'Assignee' && "_pxtolvwl _1vn8nqa1 _1ej8t94y"
            ]),
            style: {
                "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
            },
            children: columnHeader
        }, `column-header-${columnHeader}`);
    });
    const defaultRowCount = 6;
    const rowCount = rows?.length || defaultRowCount;
    const rowCells = Array.from({
        length: rowCount
    }, (_, i)=>{
        const isLastRow = i === rowCount - 1;
        if (rows && rows.length > 0 && rows[i]) {
            const { type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc } = rows[i];
            // Ensure first row defaults to epic if type is missing/undefined (only for Kanban)
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
                type: type,
                summary: summary,
                status: status,
                dueDate: dueDate,
                priority: priority,
                assignee: assignee,
                assigneeImgSrc: assigneeImgSrc,
                isLastRow: isLastRow
            }, 'row-' + i);
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
            type: i === 0 ? 'epic' : 'task',
            isLastRow: isLastRow
        }, 'row-' + i);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbxwiq _p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug _154015zi"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                className: (0, $2jatx.default)([
                    "_1kqm1wug _2rko1mvu _yq5hus1c _btyzidpf _1h6dlvwl _189et94y _1dqonqa1 _1bsb1osq _11q71afi _ect4b1j9"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
                            children: headerCells
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                        children: rowCells
                    })
                ]
            })
        })
    });
};

});
parcelRegister("hSlTI", function(module, exports) {
$parcel$export(module.exports, "TableRow", function () { return $1e73233be8a92de3$export$b05581f4e764e162; });
/* table-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $41d6y = parcelRequire("41d6y");

var $4SA4u = parcelRequire("4SA4u");

var $leqii = parcelRequire("leqii");

var $24zqb = parcelRequire("24zqb");

var $9p3p1 = parcelRequire("9p3p1");

var $h2BxV = parcelRequire("h2BxV");

var $dJqoM = parcelRequire("dJqoM");

var $20Gca = parcelRequire("20Gca");

var $kbpa7 = parcelRequire("kbpa7");
var $1e73233be8a92de3$var$StatusDisplay = /*#__PURE__*/ function(StatusDisplay) {
    StatusDisplay["ToDo"] = "TO DO";
    StatusDisplay["InProgress"] = "IN PROGRESS";
    StatusDisplay["Complete"] = "COMPLETE";
    return StatusDisplay;
}($1e73233be8a92de3$var$StatusDisplay || {});
var $1e73233be8a92de3$var$PriorityDisplay = /*#__PURE__*/ function(PriorityDisplay) {
    PriorityDisplay["Low"] = "Low";
    PriorityDisplay["Medium"] = "Medium";
    PriorityDisplay["High"] = "High";
    return PriorityDisplay;
}($1e73233be8a92de3$var$PriorityDisplay || {});
const $1e73233be8a92de3$var$inlineRowCss = null;
const $1e73233be8a92de3$var$placeHolderBarStyles = {
    root: null,
    narrow: null,
    wide: null
};
const $1e73233be8a92de3$var$lozengeStyles = {
    toDo: {
        backgroundColor: (0, $kbpa7.wacToken)('color.neutral.light300'),
        color: (0, $kbpa7.wacToken)('color.neutral.light1000')
    },
    inProgress: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.blue300'),
        color: (0, $kbpa7.wacToken)('color.neutral.light1000')
    },
    complete: {
        backgroundColor: (0, $kbpa7.wacToken)('color.extended.lime300'),
        color: (0, $kbpa7.wacToken)('color.neutral.light1000')
    }
};
const $1e73233be8a92de3$var$dateCss = null;
const $1e73233be8a92de3$var$avatarCss = null;
const $1e73233be8a92de3$var$epicSummaryCss = null;
const $1e73233be8a92de3$var$tableBorderNotLastRowCss = null;
function $1e73233be8a92de3$var$renderStatusLozenge(status) {
    switch(status){
        case 'to do':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.toDo,
                children: "TO DO"
            });
        case 'in progress':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.inProgress,
                children: "IN PROGRESS"
            });
        case 'complete':
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.complete,
                children: "COMPLETE"
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderDateLozenge(dueDate) {
    if (!dueDate) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_ect4b1j9 _k48pni7l _1wyb94pf _vwz41j6v _syazlkxj"
        ]),
        style: {
            "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000'))
        },
        children: (0, $41d6y.format)(dueDate, 'MMM do, yyyy')
    });
}
function $1e73233be8a92de3$var$renderPriority(priority) {
    switch(priority){
        case 'low':
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9p3p1))), {
                        label: "low priority",
                        color: "var(--ds-icon-accent-blue, #357DE8)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Low"
                    })
                ]
            });
        case 'medium':
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h2BxV))), {
                        label: "medium priority",
                        color: "var(--ds-icon-accent-yellow, #B38600)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Medium"
                    })
                ]
            });
        case 'high':
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24zqb))), {
                        label: "high priority",
                        color: "var(--ds-icon-accent-red, #C9372C)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "High"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc) {
    if (assignee && assigneeImgSrc) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o",
            "_1e0c116y _4cvr1h6o _zulp1kwk"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
                appearance: "circle",
                src: assigneeImgSrc,
                size: "small",
                name: assignee
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: assignee
            })
        ]
    });
    else if (assignee) return assignee;
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
}
const $1e73233be8a92de3$export$b05581f4e764e162 = ({ type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc, isLastRow: isLastRow })=>{
    const summaryIcon = type === 'epic' ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leqii))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJqoM))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
    const summaryCell = summary || /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb3jzc"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    type === 'epic' && "_k48p1fw0",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _zulp1kwk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryIcon
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryCell
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderStatusLozenge(status)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderDateLozenge(dueDate)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderPriority(priority)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc)
            })
        ]
    });
};

});
parcelRegister("41d6y", function(module, exports) {
$parcel$export(module.exports, "format", function () { return $2ed16bc14c3278e0$export$d9468344d3651243; });

var $04szs = parcelRequire("04szs");

var $52y57 = parcelRequire("52y57");

var $eULoq = parcelRequire("eULoq");

var $kaf1h = parcelRequire("kaf1h");

var $eKVtb = parcelRequire("eKVtb");

var $1vsWe = parcelRequire("1vsWe");

var $frdJf = parcelRequire("frdJf");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $2ed16bc14c3278e0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $2ed16bc14c3278e0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $2ed16bc14c3278e0$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $2ed16bc14c3278e0$var$doubleQuoteRegExp = /''/g;
const $2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2ed16bc14c3278e0$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $04szs.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $frdJf.toDate)(date, options?.in);
    if (!(0, $1vsWe.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($2ed16bc14c3278e0$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $kaf1h.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($2ed16bc14c3278e0$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $2ed16bc14c3278e0$var$cleanEscapedString(substring)
        };
        if ((0, $eULoq.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $eKVtb.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $eKVtb.isProtectedDayOfYearToken)(token)) (0, $eKVtb.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eULoq.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $2ed16bc14c3278e0$var$cleanEscapedString(input) {
    const matched = input.match($2ed16bc14c3278e0$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2ed16bc14c3278e0$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$2ed16bc14c3278e0$export$2e2bcd8739ae039 = $2ed16bc14c3278e0$export$d9468344d3651243;

});
parcelRegister("04szs", function(module, exports) {
$parcel$export(module.exports, "enUS", function () { return $00d6896abe8fc63b$export$137380d9ce54f7f; });

var $csD9X = parcelRequire("csD9X");

var $15aKy = parcelRequire("15aKy");

var $duF3D = parcelRequire("duF3D");

var $7Aogd = parcelRequire("7Aogd");

var $jkoFL = parcelRequire("jkoFL");
const $00d6896abe8fc63b$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $csD9X.formatDistance),
    formatLong: (0, $15aKy.formatLong),
    formatRelative: (0, $duF3D.formatRelative),
    localize: (0, $7Aogd.localize),
    match: (0, $jkoFL.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$00d6896abe8fc63b$export$2e2bcd8739ae039 = $00d6896abe8fc63b$export$137380d9ce54f7f;

});
parcelRegister("csD9X", function(module, exports) {
$parcel$export(module.exports, "formatDistance", function () { return $912679d4191b0f46$export$2c14ff85d6318973; });
const $912679d4191b0f46$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $912679d4191b0f46$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $912679d4191b0f46$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("15aKy", function(module, exports) {
$parcel$export(module.exports, "formatLong", function () { return $0c9e98c9816c8371$export$cbf60ecb96cbb82f; });

var $fpZN8 = parcelRequire("fpZN8");
const $0c9e98c9816c8371$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $0c9e98c9816c8371$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $0c9e98c9816c8371$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $0c9e98c9816c8371$export$cbf60ecb96cbb82f = {
    date: (0, $fpZN8.buildFormatLongFn)({
        formats: $0c9e98c9816c8371$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $fpZN8.buildFormatLongFn)({
        formats: $0c9e98c9816c8371$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $fpZN8.buildFormatLongFn)({
        formats: $0c9e98c9816c8371$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("fpZN8", function(module, exports) {
$parcel$export(module.exports, "buildFormatLongFn", function () { return $b3991f4c9478886b$export$38e44e97ce4dbb7d; });
function $b3991f4c9478886b$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("duF3D", function(module, exports) {
$parcel$export(module.exports, "formatRelative", function () { return $9d2decea181b2a3a$export$8fbbfd65594f46a0; });
const $9d2decea181b2a3a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $9d2decea181b2a3a$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$9d2decea181b2a3a$var$formatRelativeLocale[token];

});

parcelRegister("7Aogd", function(module, exports) {
$parcel$export(module.exports, "localize", function () { return $585eb6db0578e41c$export$b3bd0bc58e36cd63; });

var $98Kmv = parcelRequire("98Kmv");
const $585eb6db0578e41c$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $585eb6db0578e41c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $585eb6db0578e41c$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $585eb6db0578e41c$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $585eb6db0578e41c$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $585eb6db0578e41c$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $585eb6db0578e41c$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $585eb6db0578e41c$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $585eb6db0578e41c$var$ordinalNumber,
    era: (0, $98Kmv.buildLocalizeFn)({
        values: $585eb6db0578e41c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $98Kmv.buildLocalizeFn)({
        values: $585eb6db0578e41c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $98Kmv.buildLocalizeFn)({
        values: $585eb6db0578e41c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $98Kmv.buildLocalizeFn)({
        values: $585eb6db0578e41c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $98Kmv.buildLocalizeFn)({
        values: $585eb6db0578e41c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $585eb6db0578e41c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("98Kmv", function(module, exports) {
$parcel$export(module.exports, "buildLocalizeFn", function () { return $6a78d2eeed0806da$export$63596d6ee8878b25; });
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $6a78d2eeed0806da$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("jkoFL", function(module, exports) {
$parcel$export(module.exports, "match", function () { return $e12306114d78d37a$export$4659b591c19bdf3d; });

var $iR1Ge = parcelRequire("iR1Ge");

var $bc9qe = parcelRequire("bc9qe");
const $e12306114d78d37a$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $e12306114d78d37a$var$parseOrdinalNumberPattern = /\d+/i;
const $e12306114d78d37a$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $e12306114d78d37a$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $e12306114d78d37a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $e12306114d78d37a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e12306114d78d37a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $e12306114d78d37a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e12306114d78d37a$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $e12306114d78d37a$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $e12306114d78d37a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $e12306114d78d37a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $e12306114d78d37a$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $bc9qe.buildMatchPatternFn)({
        matchPattern: $e12306114d78d37a$var$matchOrdinalNumberPattern,
        parsePattern: $e12306114d78d37a$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $iR1Ge.buildMatchFn)({
        matchPatterns: $e12306114d78d37a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e12306114d78d37a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $iR1Ge.buildMatchFn)({
        matchPatterns: $e12306114d78d37a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e12306114d78d37a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $iR1Ge.buildMatchFn)({
        matchPatterns: $e12306114d78d37a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e12306114d78d37a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $iR1Ge.buildMatchFn)({
        matchPatterns: $e12306114d78d37a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e12306114d78d37a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $iR1Ge.buildMatchFn)({
        matchPatterns: $e12306114d78d37a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e12306114d78d37a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("iR1Ge", function(module, exports) {
$parcel$export(module.exports, "buildMatchFn", function () { return $db9e7adb651f0d6e$export$1430a0f35710914d; });
function $db9e7adb651f0d6e$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $db9e7adb651f0d6e$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $db9e7adb651f0d6e$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $db9e7adb651f0d6e$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $db9e7adb651f0d6e$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("bc9qe", function(module, exports) {
$parcel$export(module.exports, "buildMatchPatternFn", function () { return $82681fb62717ff99$export$fdaf2fd6d7edde95; });
function $82681fb62717ff99$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("52y57", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", function () { return $3ab79388ae33684b$export$430a3269e24b912e; });
let $3ab79388ae33684b$var$defaultOptions = {};
function $3ab79388ae33684b$export$430a3269e24b912e() {
    return $3ab79388ae33684b$var$defaultOptions;
}
function $3ab79388ae33684b$export$95365be1b0704abc(newOptions) {
    $3ab79388ae33684b$var$defaultOptions = newOptions;
}

});

parcelRegister("eULoq", function(module, exports) {
$parcel$export(module.exports, "formatters", function () { return $adbb0eed5a15b217$export$fe98a034cfb96d55; });

var $3vh0T = parcelRequire("3vh0T");

var $kL8sr = parcelRequire("kL8sr");

var $eOBb6 = parcelRequire("eOBb6");

var $3eRpB = parcelRequire("3eRpB");

var $kH0Cl = parcelRequire("kH0Cl");

var $3gdE9 = parcelRequire("3gdE9");

var $9evqZ = parcelRequire("9evqZ");
const $adbb0eed5a15b217$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $adbb0eed5a15b217$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $9evqZ.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $kH0Cl.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $3gdE9.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $3gdE9.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $eOBb6.getISOWeekYear)(date);
        // Padding
        return (0, $3gdE9.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $3gdE9.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $9evqZ.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $3gdE9.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3eRpB.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $kL8sr.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $9evqZ.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $3vh0T.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $3gdE9.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $3gdE9.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $9evqZ.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $9evqZ.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $9evqZ.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $9evqZ.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $9evqZ.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $3gdE9.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $3gdE9.addLeadingZeros)(+date, token.length);
    }
};
function $adbb0eed5a15b217$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $3gdE9.addLeadingZeros)(minutes, 2);
}
function $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $3gdE9.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $adbb0eed5a15b217$var$formatTimezone(offset, delimiter);
}
function $adbb0eed5a15b217$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $3gdE9.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $3gdE9.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("3vh0T", function(module, exports) {
$parcel$export(module.exports, "getDayOfYear", function () { return $28d176d71133a583$export$d3b42cd8452deec; });

var $bMbri = parcelRequire("bMbri");

var $fVuI3 = parcelRequire("fVuI3");

var $frdJf = parcelRequire("frdJf");
function $28d176d71133a583$export$d3b42cd8452deec(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const diff = (0, $bMbri.differenceInCalendarDays)(_date, (0, $fVuI3.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$28d176d71133a583$export$2e2bcd8739ae039 = $28d176d71133a583$export$d3b42cd8452deec;

});
parcelRegister("fVuI3", function(module, exports) {
$parcel$export(module.exports, "startOfYear", function () { return $b984002940bddac0$export$f91e89d3d0406102; });

var $frdJf = parcelRequire("frdJf");
function $b984002940bddac0$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $frdJf.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$b984002940bddac0$export$2e2bcd8739ae039 = $b984002940bddac0$export$f91e89d3d0406102;

});


parcelRegister("kL8sr", function(module, exports) {
$parcel$export(module.exports, "getISOWeek", function () { return $f1cec1f1d654300a$export$7cabdc5698b63e2f; });

var $59xhD = parcelRequire("59xhD");

var $beVQG = parcelRequire("beVQG");

var $lsW7j = parcelRequire("lsW7j");

var $frdJf = parcelRequire("frdJf");
function $f1cec1f1d654300a$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const diff = +(0, $beVQG.startOfISOWeek)(_date) - +(0, $lsW7j.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$f1cec1f1d654300a$export$2e2bcd8739ae039 = $f1cec1f1d654300a$export$7cabdc5698b63e2f;

});
parcelRegister("beVQG", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeek", function () { return $82ede015fb00b7b5$export$6173213f95a4431e; });

var $6cztB = parcelRequire("6cztB");
function $82ede015fb00b7b5$export$6173213f95a4431e(date, options) {
    return (0, $6cztB.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$82ede015fb00b7b5$export$2e2bcd8739ae039 = $82ede015fb00b7b5$export$6173213f95a4431e;

});
parcelRegister("6cztB", function(module, exports) {
$parcel$export(module.exports, "startOfWeek", function () { return $483f61f0ee1dce0b$export$42c81a444fbfb5d4; });

var $52y57 = parcelRequire("52y57");

var $frdJf = parcelRequire("frdJf");
function $483f61f0ee1dce0b$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$483f61f0ee1dce0b$export$2e2bcd8739ae039 = $483f61f0ee1dce0b$export$42c81a444fbfb5d4;

});


parcelRegister("lsW7j", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeekYear", function () { return $fa094b543f5dd36c$export$236bdfa374eb69a9; });

var $hs1PO = parcelRequire("hs1PO");

var $eOBb6 = parcelRequire("eOBb6");

var $beVQG = parcelRequire("beVQG");
function $fa094b543f5dd36c$export$236bdfa374eb69a9(date, options) {
    const year = (0, $eOBb6.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $hs1PO.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $beVQG.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$fa094b543f5dd36c$export$2e2bcd8739ae039 = $fa094b543f5dd36c$export$236bdfa374eb69a9;

});
parcelRegister("eOBb6", function(module, exports) {
$parcel$export(module.exports, "getISOWeekYear", function () { return $ac9292f96045be59$export$3dbc52535f6f8fcc; });

var $hs1PO = parcelRequire("hs1PO");

var $beVQG = parcelRequire("beVQG");

var $frdJf = parcelRequire("frdJf");
function $ac9292f96045be59$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$ac9292f96045be59$export$2e2bcd8739ae039 = $ac9292f96045be59$export$3dbc52535f6f8fcc;

});



parcelRegister("3eRpB", function(module, exports) {
$parcel$export(module.exports, "getWeek", function () { return $25bc1c6d66f955c1$export$efe19b760242b2fc; });

var $59xhD = parcelRequire("59xhD");

var $6cztB = parcelRequire("6cztB");

var $lLEjQ = parcelRequire("lLEjQ");

var $frdJf = parcelRequire("frdJf");
function $25bc1c6d66f955c1$export$efe19b760242b2fc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const diff = +(0, $6cztB.startOfWeek)(_date, options) - +(0, $lLEjQ.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$25bc1c6d66f955c1$export$2e2bcd8739ae039 = $25bc1c6d66f955c1$export$efe19b760242b2fc;

});
parcelRegister("lLEjQ", function(module, exports) {
$parcel$export(module.exports, "startOfWeekYear", function () { return $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $kH0Cl = parcelRequire("kH0Cl");

var $6cztB = parcelRequire("6cztB");
function $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $kH0Cl.getWeekYear)(date, options);
    const firstWeek = (0, $hs1PO.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $6cztB.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$fd8d434ee1e9a6ff$export$2e2bcd8739ae039 = $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f;

});
parcelRegister("kH0Cl", function(module, exports) {
$parcel$export(module.exports, "getWeekYear", function () { return $f1084d691f57e4eb$export$12d572480ceb6e58; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $6cztB = parcelRequire("6cztB");

var $frdJf = parcelRequire("frdJf");
function $f1084d691f57e4eb$export$12d572480ceb6e58(date, options) {
    const _date = (0, $frdJf.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $hs1PO.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $6cztB.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $hs1PO.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $6cztB.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f1084d691f57e4eb$export$2e2bcd8739ae039 = $f1084d691f57e4eb$export$12d572480ceb6e58;

});



parcelRegister("3gdE9", function(module, exports) {
$parcel$export(module.exports, "addLeadingZeros", function () { return $25fd73a5842a07c9$export$c8306e720e213c0f; });
function $25fd73a5842a07c9$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("9evqZ", function(module, exports) {
$parcel$export(module.exports, "lightFormatters", function () { return $6b8dce11d3227385$export$b0d4b338e1516f13; });

var $3gdE9 = parcelRequire("3gdE9");
const $6b8dce11d3227385$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3gdE9.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $3gdE9.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3gdE9.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("kaf1h", function(module, exports) {
$parcel$export(module.exports, "longFormatters", function () { return $eae06464081ea5f2$export$70cc8fd02856fd58; });
const $eae06464081ea5f2$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $eae06464081ea5f2$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $eae06464081ea5f2$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $eae06464081ea5f2$var$timeLongFormatter(timePattern, formatLong));
};
const $eae06464081ea5f2$export$70cc8fd02856fd58 = {
    p: $eae06464081ea5f2$var$timeLongFormatter,
    P: $eae06464081ea5f2$var$dateTimeLongFormatter
};

});

parcelRegister("eKVtb", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $abe1f0d5862b9833$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $abe1f0d5862b9833$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $abe1f0d5862b9833$export$f5f38f90ecaaf879; });
const $abe1f0d5862b9833$var$dayOfYearTokenRE = /^D+$/;
const $abe1f0d5862b9833$var$weekYearTokenRE = /^Y+$/;
const $abe1f0d5862b9833$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $abe1f0d5862b9833$export$c6cc36aa33304772(token) {
    return $abe1f0d5862b9833$var$dayOfYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$c6b49d6dceb604a1(token) {
    return $abe1f0d5862b9833$var$weekYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $abe1f0d5862b9833$var$message(token, format, input);
    console.warn(_message);
    if ($abe1f0d5862b9833$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $abe1f0d5862b9833$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("1vsWe", function(module, exports) {
$parcel$export(module.exports, "isValid", function () { return $118f223a25ac1e92$export$1ea939691cdc45b8; });

var $838H2 = parcelRequire("838H2");

var $frdJf = parcelRequire("frdJf");
function $118f223a25ac1e92$export$1ea939691cdc45b8(date) {
    return !(!(0, $838H2.isDate)(date) && typeof date !== "number" || isNaN(+(0, $frdJf.toDate)(date)));
}
var // Fallback for modularized imports:
$118f223a25ac1e92$export$2e2bcd8739ae039 = $118f223a25ac1e92$export$1ea939691cdc45b8;

});
parcelRegister("838H2", function(module, exports) {
$parcel$export(module.exports, "isDate", function () { return $5dc558d396f78e9b$export$871608497c498473; });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $5dc558d396f78e9b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$5dc558d396f78e9b$export$2e2bcd8739ae039 = $5dc558d396f78e9b$export$871608497c498473;

});



parcelRegister("24zqb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd64b41739e4b5a1ac8c09f1bbfed3e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18276e72087165bb$var$_react = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $18276e72087165bb$var$_baseNew = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $18276e72087165bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHigh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for high work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18276e72087165bb$var$PriorityHighIcon = (props)=>/*#__PURE__*/ $18276e72087165bb$var$_react.default.createElement($18276e72087165bb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.25-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353z"/>`
    }, props));
$18276e72087165bb$var$PriorityHighIcon.displayName = 'PriorityHighIcon';
var $18276e72087165bb$var$_default = module.exports.default = $18276e72087165bb$var$PriorityHighIcon;

});

parcelRegister("9p3p1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0a790d91d8a02a088319fd35139d8a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d891685efcb0c3b$var$_react = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6d891685efcb0c3b$var$_baseNew = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6d891685efcb0c3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for low work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d891685efcb0c3b$var$PriorityLowIcon = (props)=>/*#__PURE__*/ $6d891685efcb0c3b$var$_react.default.createElement($6d891685efcb0c3b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 7.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 9.352l5.087-3.353z"/>`
    }, props));
$6d891685efcb0c3b$var$PriorityLowIcon.displayName = 'PriorityLowIcon';
var $6d891685efcb0c3b$var$_default = module.exports.default = $6d891685efcb0c3b$var$PriorityLowIcon;

});

parcelRegister("h2BxV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8d7d06aafd80a5763505502d0e6cf1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c67fbf7899919f80$var$_react = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c67fbf7899919f80$var$_baseNew = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c67fbf7899919f80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for medium work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c67fbf7899919f80$var$PriorityMediumIcon = (props)=>/*#__PURE__*/ $c67fbf7899919f80$var$_react.default.createElement($c67fbf7899919f80$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 9.5V11H2V9.5zM14 5v1.5H2V5z"/>`
    }, props));
$c67fbf7899919f80$var$PriorityMediumIcon.displayName = 'PriorityMediumIcon';
var $c67fbf7899919f80$var$_default = module.exports.default = $c67fbf7899919f80$var$PriorityMediumIcon;

});



parcelRegister("jUBSR", function(module, exports) {
$parcel$export(module.exports, "JiraAiFFLProvider", function () { return $0fa7666158234ad7$export$cb2adc27ad575a30; });
$parcel$export(module.exports, "useJiraAiFFL", function () { return $0fa7666158234ad7$export$2741bae471e27db6; });

var $7VQPk = parcelRequire("7VQPk");

var $5Ntyw = parcelRequire("5Ntyw");

var $1oC0p = parcelRequire("1oC0p");

var $eLTTO = parcelRequire("eLTTO");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7XYQW = parcelRequire("7XYQW");

var $427NR = parcelRequire("427NR");

var $kYjgt = parcelRequire("kYjgt");

var $6qhMT = parcelRequire("6qhMT");

var $fx9D8 = parcelRequire("fx9D8");
const $0fa7666158234ad7$var$noop = ()=>{
/* empty */ };
const $0fa7666158234ad7$var$defaultContext = {
    submit: $0fa7666158234ad7$var$noop,
    selectedTeamType: (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT),
    setSelectedTeamType: $0fa7666158234ad7$var$noop,
    workingOnSuggestion: '',
    goalSuggestion: '',
    workingOnValue: '',
    goalValue: '',
    setWorkingOnValue: $0fa7666158234ad7$var$noop,
    setGoalValue: $0fa7666158234ad7$var$noop,
    hasUserSelectedTeamType: false,
    setHasUserSelectedTeamType: $0fa7666158234ad7$var$noop,
    hasSubmittedDefaultValues: false,
    shuffle: $0fa7666158234ad7$var$noop,
    suggestMadLib: $0fa7666158234ad7$var$noop,
    promptAttemptIndex: 0,
    commonAnalyticsAttributes: {
        flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
        experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY)
    },
    firePaidJiraAi: $0fa7666158234ad7$var$noop,
    markPromptChangedField: $0fa7666158234ad7$var$noop,
    cgsDataLoading: false,
    isErrorFromCgs: false,
    rawCgsData: undefined,
    formattedCgsData: undefined,
    setIsErrorFromCgs: $0fa7666158234ad7$var$noop
};
const $0fa7666158234ad7$var$JiraAiFFLContext = /*#__PURE__*/ (0, $1oC0p.createContext)($0fa7666158234ad7$var$defaultContext);
const $0fa7666158234ad7$export$cb2adc27ad575a30 = ({ children: children, anchor: anchor, subAnchor: subAnchor })=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eLTTO.useGoogleReCaptcha)();
    // Analytics state
    const [promptAttemptIndex, setPromptAttemptIndex] = (0, $1oC0p.useState)(0);
    const promptAttemptIndexRef = (0, $1oC0p.useRef)(0);
    const changedFieldsRef = (0, $1oC0p.useRef)(new Set());
    const [changedFieldsVersion, setChangedFieldsVersion] = (0, $1oC0p.useState)(0);
    const engagedAtRef = (0, $1oC0p.useRef)(null);
    const hasSubmittedThisAttemptRef = (0, $1oC0p.useRef)(false);
    const hasFiredViewedRef = (0, $1oC0p.useRef)(false);
    const hasFiredEngagedRef = (0, $1oC0p.useRef)(false);
    const hasFiredAbandonedRef = (0, $1oC0p.useRef)(false);
    // Shared Madlib UI state
    const [selectedTeamType, setSelectedTeamType] = (0, $1oC0p.useState)((0, $fx9D8.getTeamTypeFromAnchor)(anchor, subAnchor) ?? $0fa7666158234ad7$var$defaultContext.selectedTeamType);
    const [workingOnSuggestion, setWorkingOnSuggestion] = (0, $1oC0p.useState)('');
    const [goalSuggestion, setGoalSuggestion] = (0, $1oC0p.useState)('');
    const [workingOnValue, setWorkingOnValue] = (0, $1oC0p.useState)('');
    const [goalValue, setGoalValue] = (0, $1oC0p.useState)('');
    const [hasUserSelectedTeamType, setHasUserSelectedTeamType] = (0, $1oC0p.useState)(false);
    const [hasSubmittedDefaultValues, setHasSubmittedDefaultValues] = (0, $1oC0p.useState)(false);
    const initialSuggestion = (0, $1oC0p.useRef)();
    const suggestionsIndex = (0, $1oC0p.useRef)({
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: 0,
        [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: 0
    });
    // CGS state
    const [cgsDataLoading, setCgsDataLoading] = (0, $1oC0p.useState)(false);
    const [isErrorFromCgs, setIsErrorFromCgs] = (0, $1oC0p.useState)(false);
    const [cgsData, setCgsData] = (0, $1oC0p.useState)(undefined);
    (0, $1oC0p.useEffect)(()=>{
        promptAttemptIndexRef.current = promptAttemptIndex;
    }, [
        promptAttemptIndex
    ]);
    const getChangedFields = ()=>Array.from(changedFieldsRef.current);
    const workingOnLength = (0, $1oC0p.useMemo)(()=>workingOnValue.trim().length, [
        workingOnValue
    ]);
    const goalLength = (0, $1oC0p.useMemo)(()=>goalValue.trim().length, [
        goalValue
    ]);
    const promptType = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.derivePromptType)({
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion
        }), [
        workingOnValue,
        goalValue,
        workingOnSuggestion,
        goalSuggestion
    ]);
    const teamTypeCategory = (0, $1oC0p.useMemo)(()=>(0, $6qhMT.categorizeTeamType)(selectedTeamType), [
        selectedTeamType
    ]);
    const commonAnalyticsAttributes = (0, $1oC0p.useMemo)(()=>{
        const changedFields = getChangedFields();
        const cgsKey = typeof window !== 'undefined' ? (0, $6qhMT.getCgsKeyFromLocationHref)(window.location.href) : undefined;
        return {
            flow: (0, $6qhMT.PAID_JIRA_AI_FLOW),
            experimentKey: (0, $6qhMT.PAID_JIRA_AI_EXPERIMENT_KEY),
            teamType: selectedTeamType,
            teamTypeCategory: teamTypeCategory,
            promptAttemptIndex: promptAttemptIndex,
            isRetry: promptAttemptIndex > 1,
            promptType: promptType,
            didChangeAnything: changedFields.length > 0,
            changedFields: changedFields,
            workingOnLength: workingOnLength,
            goalLength: goalLength,
            cgsKey: cgsKey
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedTeamType,
        teamTypeCategory,
        promptAttemptIndex,
        promptType,
        workingOnLength,
        goalLength,
        changedFieldsVersion
    ]);
    const firePaidJiraAi = (0, $1oC0p.useCallback)((step, action, attributes = {})=>{
        (0, $6qhMT.firePaidJiraAiEvent)(createAnalyticsEvent, {
            step: step,
            action: action,
            attributes: {
                ...commonAnalyticsAttributes,
                ...attributes
            }
        });
    }, [
        createAnalyticsEvent,
        commonAnalyticsAttributes
    ]);
    const markPromptEngaged = (0, $1oC0p.useCallback)(()=>{
        if (!engagedAtRef.current) engagedAtRef.current = performance.now();
        if (!hasFiredEngagedRef.current) {
            hasFiredEngagedRef.current = true;
            firePaidJiraAi('PromptEngaged', 'started');
        }
    }, [
        firePaidJiraAi
    ]);
    const markPromptChangedField = (0, $1oC0p.useCallback)((field)=>{
        markPromptEngaged();
        if (!changedFieldsRef.current.has(field)) {
            changedFieldsRef.current.add(field);
            setChangedFieldsVersion((v)=>v + 1);
        }
    }, [
        markPromptEngaged
    ]);
    // Prompt view + abandonment tracking
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFiredViewedRef.current) {
            hasFiredViewedRef.current = true;
            firePaidJiraAi('PromptViewed', 'viewed');
        }
        const maybeFireAbandoned = ()=>{
            if (hasFiredAbandonedRef.current) return;
            if (!engagedAtRef.current || hasSubmittedThisAttemptRef.current) return;
            hasFiredAbandonedRef.current = true;
            firePaidJiraAi('PromptAbandoned', 'closed', {
                dwellMs: Math.max(0, performance.now() - engagedAtRef.current)
            });
        };
        window.addEventListener('pagehide', maybeFireAbandoned);
        const onVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') maybeFireAbandoned();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            window.removeEventListener('pagehide', maybeFireAbandoned);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [
        firePaidJiraAi
    ]);
    const suggestMadLib = (teamType)=>{
        const t = teamType || selectedTeamType;
        const suggestions = (0, $kYjgt.getSuggestionsForTeamType)(t);
        suggestionsIndex.current[t] = (suggestionsIndex.current[t] || 0) + 1;
        if (!suggestions[suggestionsIndex.current[t]]) suggestionsIndex.current[t] = 0;
        const suggestion = suggestions[suggestionsIndex.current[t]];
        const workingOnSuggestion = intl.formatMessage(suggestion?.task);
        const goalSuggestion = intl.formatMessage(suggestion?.goal);
        setWorkingOnSuggestion(workingOnSuggestion);
        setGoalSuggestion(goalSuggestion);
        if (!initialSuggestion.current) initialSuggestion.current = {
            workingOn: workingOnSuggestion,
            goal: goalSuggestion
        };
        setWorkingOnValue('');
        setGoalValue('');
    };
    // Compute anchor config synchronously during render to avoid a production
    // scope-hoisting issue where the minified `anchor` variable inside the
    // useEffect closure resolves to a different binding (markPromptChangedField).
    const anchorConfig = (0, $1oC0p.useMemo)(()=>(0, $fx9D8.getAnchorConfig)(anchor, subAnchor), [
        anchor,
        subAnchor
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $1oC0p.useEffect)(()=>{
        if (anchorConfig) {
            setSelectedTeamType(anchorConfig.teamType);
            suggestionsIndex.current[anchorConfig.teamType] = anchorConfig.suggestionIndex - 1;
            suggestMadLib(anchorConfig.teamType);
        } else suggestMadLib();
    }, [
        anchorConfig
    ]);
    const shuffle = ()=>{
        markPromptChangedField('shuffle');
        firePaidJiraAi('PromptShuffleClicked', 'clicked', {
            cta: 'shuffle'
        });
        if (!hasUserSelectedTeamType) {
            const teamTypes = Object.keys((0, $fx9D8.teamTypesMap));
            const randomTeamType = teamTypes[Math.floor(Math.random() * teamTypes.length)];
            setSelectedTeamType(randomTeamType);
            suggestMadLib(randomTeamType);
        } else suggestMadLib();
    };
    const formattedCgsData = (0, $1oC0p.useMemo)(()=>{
        if (cgsDataLoading || !cgsData) return undefined;
        return (0, $fx9D8.formatCgsData)(cgsData);
    }, [
        cgsData,
        cgsDataLoading
    ]);
    const getRecaptchaOutcome = async ()=>{
        const recaptchaStart = performance.now();
        let token;
        let recaptchaError;
        try {
            token = await (0, $427NR.getRecaptcha)('', // paid landing is anonymous; token still binds to browser context
            executeRecaptcha);
        } catch (e) {
            recaptchaError = e;
            token = undefined;
        }
        const recaptchaTimeMs = Math.max(0, performance.now() - recaptchaStart);
        const result = token ? 'token' : recaptchaError ? 'error' : 'empty';
        if (token) firePaidJiraAi('RecaptchaTokenSucceeded', 'succeeded', {
            recaptchaTimeMs: recaptchaTimeMs
        });
        else firePaidJiraAi('RecaptchaTokenFailed', 'failed', {
            recaptchaTimeMs: recaptchaTimeMs,
            failureReason: recaptchaError ? 'error' : 'empty',
            ...(0, $6qhMT.safeErrorContext)(recaptchaError)
        });
        return {
            token: token ?? '',
            recaptchaTimeMs: recaptchaTimeMs,
            result: result
        };
    };
    const setCgsKeyInUrl = (cgsKey)=>{
        // Persist cgsKey in the URL so downstream flows (e.g. account creation)
        // can pick it up without depending on this context provider.
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('cgsKey', cgsKey);
        window.history.replaceState(null, '', nextUrl.toString());
    };
    const submit = async (update)=>{
        const { teamType: teamType, workingOn: workingOn, goal: goal } = update;
        const attemptIndex = promptAttemptIndexRef.current + 1;
        const submitStart = performance.now();
        hasSubmittedThisAttemptRef.current = true;
        hasFiredAbandonedRef.current = false;
        const derived = {
            promptAttemptIndex: attemptIndex,
            isRetry: attemptIndex > 1,
            promptType: promptType,
            didChangeAnything: getChangedFields().length > 0,
            changedFields: getChangedFields(),
            workingOnLength: workingOnLength,
            goalLength: goalLength
        };
        setPromptAttemptIndex(attemptIndex);
        setCgsDataLoading(true);
        setIsErrorFromCgs(false);
        let recaptchaOutcome;
        try {
            // Explicit lifecycle start (click is tracked separately in the prompt component).
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_STARTED),
                eventType: 'track',
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: {
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    ...derived
                }
            }).fire();
            firePaidJiraAi('ContentGenStarted', 'started', derived);
            // Be resilient: even if reCAPTCHA is empty/errored, proceed and let the API
            // decide whether it's required.
            recaptchaOutcome = await getRecaptchaOutcome();
            setHasSubmittedDefaultValues(teamType === $0fa7666158234ad7$var$defaultContext.selectedTeamType && workingOn === initialSuggestion.current?.workingOn && goal === initialSuggestion.current?.goal);
            const response = await stargateClient.postContentGenerationForJiraFfl({
                teamType: teamType,
                workingOnSummary: workingOn,
                goal: goal,
                gRecaptchaResponse: recaptchaOutcome.token
            });
            setCgsData(response);
            setCgsKeyInUrl(response.cacheKey);
            setCgsDataLoading(false);
            const rowCount = (0, $fx9D8.formatCgsData)(response)?.length ?? 0;
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                eventType: 'track',
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: {
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    rowCount: rowCount,
                    recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome.result,
                    ...derived
                }
            }).fire();
            firePaidJiraAi('ContentGenSucceeded', 'succeeded', {
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                rowCount: rowCount,
                recaptchaTimeMs: recaptchaOutcome.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome.result,
                ...derived
            });
        } catch (error) {
            setCgsDataLoading(false);
            setIsErrorFromCgs(true);
            setCgsData((0, $fx9D8.fallbackCgsData));
            setCgsKeyInUrl((0, $fx9D8.fallbackCgsData).cacheKey);
            const safe = (0, $6qhMT.safeErrorContext)(error);
            createAnalyticsEvent({
                action: (0, $fx9D8.ANALYTIC_EVENT_ACTION_FAILED),
                eventType: 'track',
                actionSubject: (0, $fx9D8.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: {
                    teamType: teamType,
                    flow: (0, $fx9D8.MADLIB_FLOW),
                    error: error.message,
                    timeToCgsMs: Math.max(0, performance.now() - submitStart),
                    recaptchaTimeMs: recaptchaOutcome?.recaptchaTimeMs,
                    recaptchaResult: recaptchaOutcome?.result,
                    ...derived,
                    ...safe
                }
            }).fire();
            firePaidJiraAi('ContentGenFailed', 'failed', {
                timeToCgsMs: Math.max(0, performance.now() - submitStart),
                recaptchaTimeMs: recaptchaOutcome?.recaptchaTimeMs,
                recaptchaResult: recaptchaOutcome?.result,
                ...derived,
                ...safe
            });
        } finally{
            // Reset engagement tracking for the next attempt.
            engagedAtRef.current = null;
            hasSubmittedThisAttemptRef.current = false;
            hasFiredEngagedRef.current = false;
            changedFieldsRef.current = new Set();
            setChangedFieldsVersion((v)=>v + 1);
        }
    };
    const value = (0, $1oC0p.useMemo)(()=>({
            submit: submit,
            // Madlib UI state
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            selectedTeamType: selectedTeamType,
            setSelectedTeamType: setSelectedTeamType,
            workingOnSuggestion: workingOnSuggestion,
            goalSuggestion: goalSuggestion,
            workingOnValue: workingOnValue,
            goalValue: goalValue,
            setWorkingOnValue: setWorkingOnValue,
            setGoalValue: setGoalValue,
            hasUserSelectedTeamType: hasUserSelectedTeamType,
            setHasUserSelectedTeamType: setHasUserSelectedTeamType,
            hasSubmittedDefaultValues: hasSubmittedDefaultValues,
            shuffle: shuffle,
            suggestMadLib: suggestMadLib,
            promptAttemptIndex: promptAttemptIndex,
            commonAnalyticsAttributes: commonAnalyticsAttributes,
            firePaidJiraAi: firePaidJiraAi,
            markPromptChangedField: markPromptChangedField,
            cgsDataLoading: // CGS
            cgsDataLoading,
            isErrorFromCgs: isErrorFromCgs,
            rawCgsData: cgsData,
            formattedCgsData: formattedCgsData,
            setIsErrorFromCgs: setIsErrorFromCgs
        }), [
        submit,
        selectedTeamType,
        workingOnSuggestion,
        goalSuggestion,
        workingOnValue,
        goalValue,
        hasUserSelectedTeamType,
        hasSubmittedDefaultValues,
        shuffle,
        suggestMadLib,
        promptAttemptIndex,
        commonAnalyticsAttributes,
        firePaidJiraAi,
        markPromptChangedField,
        cgsDataLoading,
        isErrorFromCgs,
        cgsData,
        formattedCgsData,
        setIsErrorFromCgs
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0fa7666158234ad7$var$JiraAiFFLContext.Provider, {
        value: value,
        children: children
    });
};
const $0fa7666158234ad7$export$2741bae471e27db6 = ()=>(0, $1oC0p.useContext)($0fa7666158234ad7$var$JiraAiFFLContext);

});
parcelRegister("kYjgt", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $96f168e338d9fe03$export$defe85febe8b728c; });
$parcel$export(module.exports, "getSuggestionsForTeamType", function () { return $96f168e338d9fe03$export$1699afe393f55639; });

var $fnHPc = parcelRequire("fnHPc");

var $7XYQW = parcelRequire("7XYQW");
const $96f168e338d9fe03$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    getToDoneFaster: {
        id: 'PaidLanding.JiraAI.getToDoneFaster',
        defaultMessage: 'Get to <highlight>done</highlight> faster with Jira + Rovo',
        description: 'Page header'
    },
    aiPoweredProjectManagement: {
        id: 'PaidLanding.JiraAI.aiPoweredProjectManagement',
        defaultMessage: 'AI-powered project management that removes the work around work.',
        description: 'Description below the page header'
    },
    softwareDevelopment: {
        id: 'PaidLanding.JiraAI.madLibPrompt.softwareDevelopment',
        defaultMessage: 'Software development',
        description: 'Mad-lib suggestion option 1'
    },
    productManagement: {
        id: 'PaidLanding.JiraAI.madLibPrompt.productManagement',
        defaultMessage: 'Product management',
        description: 'Mad-lib suggestion option 2'
    },
    marketing: {
        id: 'PaidLanding.JiraAI.madLibPrompt.marketing',
        defaultMessage: 'Marketing',
        description: 'Mad-lib suggestion option 3'
    },
    projectManagement: {
        id: 'PaidLanding.JiraAI.madLibPrompt.projectManagement',
        defaultMessage: 'Project management',
        description: 'Mad-lib suggestion option 4'
    },
    design: {
        id: 'PaidLanding.JiraAI.madLibPrompt.design',
        defaultMessage: 'Design',
        description: 'Mad-lib suggestion option 5'
    },
    it: {
        id: 'PaidLanding.JiraAI.madLibPrompt.it',
        defaultMessage: 'IT',
        description: 'Mad-lib suggestion option 6'
    },
    madLib: {
        id: 'PaidLanding.JiraAI.madLibPrompt.madLib',
        defaultMessage: "<workingOn>I'm working on</workingOn> {workingOnInput} <goal>with the goal of</goal> {goalInput}",
        description: "Ex: I'm working on brand awareness campaign with the goal of driving 25% more signups across email, paid, and social channels"
    },
    poweredByAi: {
        id: 'PaidLanding.JiraAI.madLibPrompt.poweredByAi',
        defaultMessage: 'Uses AI. Verify results.',
        description: 'Description in mad-lib prompt footer'
    },
    shuffle: {
        id: 'PaidLanding.JiraAI.madLibPrompt.shuffle',
        defaultMessage: 'Shuffle',
        description: 'Button text to shuffle mad-lib'
    },
    getStarted: {
        id: 'PaidLanding.JiraAI.madLibPrompt.getStarted',
        defaultMessage: 'Get started',
        description: 'Button text to submit mad-lib'
    },
    rerunPrompt: {
        id: 'PaidLanding.JiraAI.madLibPrompt.rerunPrompt',
        defaultMessage: 'Rerun prompt',
        description: 'Button text to submit mad-lib'
    },
    working: {
        id: 'PaidLanding.JiraAI.madLibPrompt.working',
        defaultMessage: 'Working...',
        description: 'Button text for loading message'
    },
    close: {
        id: 'PaidLanding.JiraAI.previewModal.close',
        defaultMessage: 'Close',
        description: 'Label for the close button'
    },
    paidJiraAiPreviewModal: {
        id: 'PaidLanding.JiraAI.signup.previewBackground.paidJiraAiPreviewModal',
        defaultMessage: 'Paid Jira AI Preview Modal',
        description: 'Aria label for preview modal'
    },
    acceptableUsePolicyDisclaimer: {
        id: 'PaidLanding.JiraAI.acceptableUsePolicyDisclaimer',
        defaultMessage: 'By selecting "Generate Jira plan," you agree to use of a feature that is subject to Atlassian\'s <acceptableUsePolicyLink>Acceptable Use Policy</acceptableUsePolicyLink>.',
        description: 'Acceptable use policy disclaimer'
    }
});
const $96f168e338d9fe03$export$3e3e8e3ace2d7f0e = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.1.ffl.content',
        defaultMessage: 'Feature release with the goal of meeting a key user need',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.1.ffl.task',
        defaultMessage: 'feature release',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.1.ffl.goal',
        defaultMessage: 'meeting a key user need',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$4083d838b33ee248 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.2.ffl.content',
        defaultMessage: 'Platform migration with the goal of improving reliability',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.2.ffl.task',
        defaultMessage: 'platform migration',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.2.ffl.goal',
        defaultMessage: 'improving reliability',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$238954bdf622c599 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.3.ffl.content',
        defaultMessage: 'Backend revamp with the goal of improving system performance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.3.ffl.task',
        defaultMessage: 'backend revamp',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.3.ffl.goal',
        defaultMessage: 'improving system performance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$e67cd156d6d6f2ae = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.4.ffl.content',
        defaultMessage: 'Design system update with the goal of unifying components',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.4.ffl.task',
        defaultMessage: 'design system update',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.4.ffl.goal',
        defaultMessage: 'unifying components',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$c859d4b806b7c319 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.5.ffl.content',
        defaultMessage: 'API integration project with the goal of connecting new services',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.5.ffl.task',
        defaultMessage: 'api integration project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.5.ffl.goal',
        defaultMessage: 'connecting new services',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$aa93c7dd62258c4c = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.6.ffl.content',
        defaultMessage: 'Mobile app launch with the goal of delivering a responsive design',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.6.ffl.task',
        defaultMessage: 'mobile app launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.6.ffl.goal',
        defaultMessage: 'delivering a responsive design',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$5eb899ea0abf885b = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.7.ffl.content',
        defaultMessage: 'Security fix with the goal of resolving vulnerabilities',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.7.ffl.task',
        defaultMessage: 'security fix',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.7.ffl.goal',
        defaultMessage: 'resolving vulnerabilities',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$fffcfc2b88cf5096 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.8.ffl.content',
        defaultMessage: 'Performance optimization with the goal of speeding up the app',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.8.ffl.task',
        defaultMessage: 'performance optimization',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.8.ffl.goal',
        defaultMessage: 'speeding up the app',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9fe450f0fded883a = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.softwareDevelopment.9.ffl.content',
        defaultMessage: 'Engineering sprint with the goal of QAing live prototypes built with AI',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.softwareDevelopment.9.ffl.task',
        defaultMessage: 'engineering sprint',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.softwareDevelopment.9.ffl.goal',
        defaultMessage: 'QAing live prototypes built with AI',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ec5ddcbed75bc531 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.softwareDevelopment.10.ffl.content',
        defaultMessage: 'Bug tracking initiative with the goal of resolving defects before feature launch',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.softwareDevelopment.10.ffl.task',
        defaultMessage: 'bug tracking initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.softwareDevelopment.10.ffl.goal',
        defaultMessage: 'resolving defects before feature launch',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$d946a96bae566935 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.9.ffl.content',
        defaultMessage: 'Product launch with the goal of shipping a new service to market',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.9.ffl.task',
        defaultMessage: 'product launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.9.ffl.goal',
        defaultMessage: 'shipping a new service to market',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$7c01f95ee53b1178 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.10.ffl.content',
        defaultMessage: 'Feature launch with the goal of delivering value to users',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.10.ffl.task',
        defaultMessage: 'feature launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.10.ffl.goal',
        defaultMessage: 'delivering value to users',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$2f763ba3e5452cc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.11.ffl.content',
        defaultMessage: 'Strategic plan with the goal of creating a clear roadmap',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.11.ffl.task',
        defaultMessage: 'strategic plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.11.ffl.goal',
        defaultMessage: 'creating a clear roadmap',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$1397ef1e776ed951 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.12.ffl.content',
        defaultMessage: 'Customer research study with the goal of gathering insights',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.12.ffl.task',
        defaultMessage: 'customer research study',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.12.ffl.goal',
        defaultMessage: 'gathering insights',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8cad710146c3f103 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.13.ffl.content',
        defaultMessage: 'Platform upgrade with the goal of improving reliability',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.13.ffl.task',
        defaultMessage: 'platform upgrade',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.13.ffl.goal',
        defaultMessage: 'improving reliability',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$51ac07ea9a8753b7 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.14.ffl.content',
        defaultMessage: 'Analytics project with the goal of tracking key metrics',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.14.ffl.task',
        defaultMessage: 'analytics project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.14.ffl.goal',
        defaultMessage: 'tracking key metrics',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$aa3333d2f7d341a9 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.15.ffl.content',
        defaultMessage: 'Quarterly product plan with the goal of creating a strong backlog',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.15.ffl.task',
        defaultMessage: 'quarterly product plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.15.ffl.goal',
        defaultMessage: 'creating a strong backlog',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ba89ed94fac4b472 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.16.ffl.content',
        defaultMessage: 'A/B experiment with the goal of optimizing an experience',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.16.ffl.task',
        defaultMessage: 'a/b experiment',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.16.ffl.goal',
        defaultMessage: 'optimizing an experience',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$700e64e0f0dceb08 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.17.ffl.content',
        defaultMessage: 'Campaign launch with the goal of driving brand awareness',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.17.ffl.task',
        defaultMessage: 'campaign launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.17.ffl.goal',
        defaultMessage: 'driving brand awareness',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$50293e2ec360ad90 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.18.ffl.content',
        defaultMessage: 'Content strategy with the goal of improving SEO',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.18.ffl.task',
        defaultMessage: 'content strategy',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.18.ffl.goal',
        defaultMessage: 'improving SEO',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$2c612aa5d867d94d = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.19.ffl.content',
        defaultMessage: 'Referral program with the goal of growing customers via referrals',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.19.ffl.task',
        defaultMessage: 'referral program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.19.ffl.goal',
        defaultMessage: 'growing customers via referrals',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$75d56ecc14891dc1 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.20.ffl.content',
        defaultMessage: 'Social media campaign with the goal of increasing engagement',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.20.ffl.task',
        defaultMessage: 'social media campaign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.20.ffl.goal',
        defaultMessage: 'increasing engagement',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$10d5913842e26806 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.21.ffl.content',
        defaultMessage: 'Influencer partnership with the goal of reaching new audiences',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.21.ffl.task',
        defaultMessage: 'influencer partnership',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.21.ffl.goal',
        defaultMessage: 'reaching new audiences',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$e32f3ee079464889 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.22.ffl.content',
        defaultMessage: 'Promotional event with the goal of driving brand awareness',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.22.ffl.task',
        defaultMessage: 'promotional event',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.22.ffl.goal',
        defaultMessage: 'driving brand awareness',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$3c2846799041acd1 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.23.ffl.content',
        defaultMessage: 'Email campaign with the goal of generating leads',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.23.ffl.task',
        defaultMessage: 'email campaign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.23.ffl.goal',
        defaultMessage: 'generating leads',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$28f387abcb0b61c2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.24.ffl.content',
        defaultMessage: 'Paid advertising with the goal of reaching new customers',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.24.ffl.task',
        defaultMessage: 'paid advertising',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.24.ffl.goal',
        defaultMessage: 'reaching new customers',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$217ea0fee69755b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.25.ffl.content',
        defaultMessage: 'Cross-team launch with the goal of delivering a new service',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.25.ffl.task',
        defaultMessage: 'cross-team launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.25.ffl.goal',
        defaultMessage: 'delivering a new service',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ba7d0398d02cd9c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.26.ffl.content',
        defaultMessage: 'System upgrade with the goal of improving performance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.26.ffl.task',
        defaultMessage: 'system upgrade',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.26.ffl.goal',
        defaultMessage: 'improving performance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$510943abc3818b56 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.27.ffl.content',
        defaultMessage: 'Training program with the goal of upskilling team members',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.27.ffl.task',
        defaultMessage: 'training program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.27.ffl.goal',
        defaultMessage: 'upskilling team members',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$eb28136e581b59a2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.28.ffl.content',
        defaultMessage: 'Communication strategy with the goal of aligning stakeholders',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.28.ffl.task',
        defaultMessage: 'communication strategy',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.28.ffl.goal',
        defaultMessage: 'aligning stakeholders',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$fb13f40a79e19ca5 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.29.ffl.content',
        defaultMessage: 'Event planning initiative with the goal of engaging participants',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.29.ffl.task',
        defaultMessage: 'event planning initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.29.ffl.goal',
        defaultMessage: 'engaging participants',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$443d3648968f7329 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.30.ffl.content',
        defaultMessage: 'Process optimization project with the goal of increasing efficiency',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.30.ffl.task',
        defaultMessage: 'process optimization project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.30.ffl.goal',
        defaultMessage: 'increasing efficiency',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$b47a1b25f95c27f7 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.31.ffl.content',
        defaultMessage: 'Company-wide initiative with the goal of improving collaboration',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.31.ffl.task',
        defaultMessage: 'company-wide initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.31.ffl.goal',
        defaultMessage: 'improving collaboration',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ff468a2badd833da = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.32.ffl.content',
        defaultMessage: 'Technology upgrade with the goal of modernizing our tools',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.32.ffl.task',
        defaultMessage: 'technology upgrade',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.32.ffl.goal',
        defaultMessage: 'modernizing our tools',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$5a07aeb3f31820fd = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.33.ffl.content',
        defaultMessage: 'Dashboard with the goal of tracking performance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.33.ffl.task',
        defaultMessage: 'dashboard',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.33.ffl.goal',
        defaultMessage: 'tracking performance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$dfd30a31c0976d81 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.34.ffl.content',
        defaultMessage: 'Segmentation model with the goal of driving personalization',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.34.ffl.task',
        defaultMessage: 'segmentation model',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.34.ffl.goal',
        defaultMessage: 'driving personalization',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$95dbb3526f288923 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.35.ffl.content',
        defaultMessage: 'Predictive model with the goal of forecasting demand',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.35.ffl.task',
        defaultMessage: 'predictive model',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.35.ffl.goal',
        defaultMessage: 'forecasting demand',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$70448386f1965d8f = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.36.ffl.content',
        defaultMessage: 'A/B test analysis with the goal of measuring experiment impact',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.36.ffl.task',
        defaultMessage: 'a/b test analysis',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.36.ffl.goal',
        defaultMessage: 'measuring experiment impact',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9b985ff42826fe70 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.37.ffl.content',
        defaultMessage: 'Churn analysis with the goal of reducing customer loss',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.37.ffl.task',
        defaultMessage: 'churn analysis',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.37.ffl.goal',
        defaultMessage: 'reducing customer loss',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$90db3bc5ac7e2675 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.38.ffl.content',
        defaultMessage: 'Data pipeline with the goal of improving data quality',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.38.ffl.task',
        defaultMessage: 'data pipeline',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.38.ffl.goal',
        defaultMessage: 'improving data quality',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$cacf7e1270784764 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.39.ffl.content',
        defaultMessage: 'Data lake migration with the goal of centralizing datasets',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.39.ffl.task',
        defaultMessage: 'data lake migration',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.39.ffl.goal',
        defaultMessage: 'centralizing datasets',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$73dab2578d6196e = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.40.ffl.content',
        defaultMessage: 'Funnel analysis with the goal of identifying new opportunities',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.40.ffl.task',
        defaultMessage: 'funnel analysis',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.40.ffl.goal',
        defaultMessage: 'identifying new opportunities',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$e89b21d7e4f = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.41.ffl.content',
        defaultMessage: 'Lead generation project with the goal of finding new customers',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.41.ffl.task',
        defaultMessage: 'lead generation project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.41.ffl.goal',
        defaultMessage: 'finding new customers',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$7552cab841864320 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.42.ffl.content',
        defaultMessage: 'Sales campaign with the goal of increasing revenue',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.42.ffl.task',
        defaultMessage: 'sales campaign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.42.ffl.goal',
        defaultMessage: 'increasing revenue',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$7a24837b79d45438 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.43.ffl.content',
        defaultMessage: 'Account plan with the goal of growing client relationships',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.43.ffl.task',
        defaultMessage: 'account plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.43.ffl.goal',
        defaultMessage: 'growing client relationships',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8b9f0dc25b70b492 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.44.ffl.content',
        defaultMessage: 'Sales kickoff plan with the goal of driving sales growth',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.44.ffl.task',
        defaultMessage: 'sales kickoff plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.44.ffl.goal',
        defaultMessage: 'driving sales growth',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$6aaa62a0350d7e26 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.45.ffl.content',
        defaultMessage: 'Pipeline optimization with the goal of increasing deal flow',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.45.ffl.task',
        defaultMessage: 'pipeline optimization',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.45.ffl.goal',
        defaultMessage: 'increasing deal flow',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$2998d96008544a57 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.46.ffl.content',
        defaultMessage: 'Sales training program with the goal of improving team skills',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.46.ffl.task',
        defaultMessage: 'sales training program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.46.ffl.goal',
        defaultMessage: 'improving team skills',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9f50b52f7978030 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.47.ffl.content',
        defaultMessage: 'Market analysis with the goal of identifying new opportunities',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.47.ffl.task',
        defaultMessage: 'market analysis',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.47.ffl.goal',
        defaultMessage: 'identifying new opportunities',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$233be78d085cc677 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.48.ffl.content',
        defaultMessage: 'Customer retention initiative with the goal of reducing churn',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.48.ffl.task',
        defaultMessage: 'customer retention initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.48.ffl.goal',
        defaultMessage: 'reducing churn',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9a70a449effffd31 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.49.ffl.content',
        defaultMessage: 'Annual budget plan with the goal of optimizing resource allocation',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.49.ffl.task',
        defaultMessage: 'annual budget plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.49.ffl.goal',
        defaultMessage: 'optimizing resource allocation',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$b42e1c0dd11c43a8 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.50.ffl.content',
        defaultMessage: 'Financial dashboard with the goal of surfacing key metrics',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.50.ffl.task',
        defaultMessage: 'financial dashboard',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.50.ffl.goal',
        defaultMessage: 'surfacing key metrics',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$c75ce3d04975da18 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.51.ffl.content',
        defaultMessage: 'Financial audit preparation with the goal of ensuring compliance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.51.ffl.task',
        defaultMessage: 'financial audit preparation',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.51.ffl.goal',
        defaultMessage: 'ensuring compliance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$7d4e88dfaf5cfbf2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.52.ffl.content',
        defaultMessage: 'Cost reduction project with the goal of improving profitability',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.52.ffl.task',
        defaultMessage: 'cost reduction project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.52.ffl.goal',
        defaultMessage: 'improving profitability',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$edc324362fedbd80 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.53.ffl.content',
        defaultMessage: 'Forecasting project with the goal of predicting revenue',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.53.ffl.task',
        defaultMessage: 'forecasting project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.53.ffl.goal',
        defaultMessage: 'predicting revenue',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$fe3389126f5cb0d8 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.54.ffl.content',
        defaultMessage: 'Automation project with the goal of streamlining operations',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.54.ffl.task',
        defaultMessage: 'automation project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.54.ffl.goal',
        defaultMessage: 'streamlining operations',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$dd6b1ebf96801fbc = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.55.ffl.content',
        defaultMessage: 'Technology upgrade with the goal of modernizing our systems',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.55.ffl.task',
        defaultMessage: 'technology upgrade',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.55.ffl.goal',
        defaultMessage: 'modernizing our systems',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$4d5e8549a481dc8f = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.56.ffl.content',
        defaultMessage: 'Tax planning initiative with the goal of ensuring compliance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.56.ffl.task',
        defaultMessage: 'tax planning initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.56.ffl.goal',
        defaultMessage: 'ensuring compliance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$93f014d48a475135 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.57.ffl.content',
        defaultMessage: 'Contract review project with the goal of faster approvals',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.57.ffl.task',
        defaultMessage: 'contract review project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.57.ffl.goal',
        defaultMessage: 'faster approvals',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$d11bd1cb56453b28 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.58.ffl.content',
        defaultMessage: 'Compliance rollout with the goal of meeting regulatory standards',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.58.ffl.task',
        defaultMessage: 'compliance rollout',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.58.ffl.goal',
        defaultMessage: 'meeting regulatory standards',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$4c3a6919fce6fd40 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.59.ffl.content',
        defaultMessage: 'Property transaction with the goal of finalizing a deal',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.59.ffl.task',
        defaultMessage: 'property transaction',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.59.ffl.goal',
        defaultMessage: 'finalizing a deal',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$c439b80ed7353230 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.60.ffl.content',
        defaultMessage: 'IP litigation case with the goal of protecting intellectual property',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.60.ffl.task',
        defaultMessage: 'ip litigation case',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.60.ffl.goal',
        defaultMessage: 'protecting intellectual property',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ea984107697503fc = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.61.ffl.content',
        defaultMessage: 'Legal intake portal with the goal of streamlining request handling',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.61.ffl.task',
        defaultMessage: 'legal intake portal',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.61.ffl.goal',
        defaultMessage: 'streamlining request handling',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$28e7793f76656931 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.62.ffl.content',
        defaultMessage: 'Data privacy project with the goal of protecting customer data',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.62.ffl.task',
        defaultMessage: 'data privacy project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.62.ffl.goal',
        defaultMessage: 'protecting customer data',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$1da97b56a73dc2b2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.63.ffl.content',
        defaultMessage: 'Employee policy review with the goal of ensuring compliance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.63.ffl.task',
        defaultMessage: 'employee policy review',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.63.ffl.goal',
        defaultMessage: 'ensuring compliance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ced6c8fb350e76bb = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.64.ffl.content',
        defaultMessage: 'Legal tech adoption plan with the goal of improving team efficiency',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.64.ffl.task',
        defaultMessage: 'legal tech adoption plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.64.ffl.goal',
        defaultMessage: 'improving team efficiency',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a4bf996d2c840321 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.65.ffl.content',
        defaultMessage: 'Support project with the goal of monitoring requests',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.65.ffl.task',
        defaultMessage: 'support project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.65.ffl.goal',
        defaultMessage: 'monitoring requests',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$673f161eccda0fd2 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.66.ffl.content',
        defaultMessage: 'Knowledge base redesign with the goal of simplifying resources',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.66.ffl.task',
        defaultMessage: 'knowledge base redesign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.66.ffl.goal',
        defaultMessage: 'simplifying resources',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$16b6eaa2913019eb = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.67.ffl.content',
        defaultMessage: 'AI chat tool with the goal of automating responses',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.67.ffl.task',
        defaultMessage: 'ai chat tool',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.67.ffl.goal',
        defaultMessage: 'automating responses',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$747e538403f25754 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.68.ffl.content',
        defaultMessage: 'Customer feedback survey with the goal of gathering insights',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.68.ffl.task',
        defaultMessage: 'customer feedback survey',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.68.ffl.goal',
        defaultMessage: 'gathering insights',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$131cdd783f6832db = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.69.ffl.content',
        defaultMessage: 'Process optimization with the goal of reducing bottlenecks',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.69.ffl.task',
        defaultMessage: 'process optimization',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.69.ffl.goal',
        defaultMessage: 'reducing bottlenecks',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$b39996d55eda2c57 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.70.ffl.content',
        defaultMessage: 'Multi-channel integration with the goal of centralizing interactions',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.70.ffl.task',
        defaultMessage: 'multi-channel integration',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.70.ffl.goal',
        defaultMessage: 'centralizing interactions',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$db220d81a1a51dbb = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.71.ffl.content',
        defaultMessage: 'Support dashboard with the goal of tracking key metrics',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.71.ffl.task',
        defaultMessage: 'support dashboard',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.71.ffl.goal',
        defaultMessage: 'tracking key metrics',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$22b3d354cda23d40 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.72.ffl.content',
        defaultMessage: 'Training program with the goal of improving team skills',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.72.ffl.task',
        defaultMessage: 'training program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.72.ffl.goal',
        defaultMessage: 'improving team skills',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$116ac96c94b3d638 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.73.ffl.content',
        defaultMessage: 'New hire onboarding with the goal of ramping up employees',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.73.ffl.task',
        defaultMessage: 'new hire onboarding',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.73.ffl.goal',
        defaultMessage: 'ramping up employees',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a2ffbc021439bdbd = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.74.ffl.content',
        defaultMessage: 'Employee training with the goal of building skills',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.74.ffl.task',
        defaultMessage: 'employee training',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.74.ffl.goal',
        defaultMessage: 'building skills',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$de23ac620cd66202 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.75.ffl.content',
        defaultMessage: 'Performance review process with the goal of evaluating growth',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.75.ffl.task',
        defaultMessage: 'performance review process',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.75.ffl.goal',
        defaultMessage: 'evaluating growth',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$22b19d3e0decb8c0 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.76.ffl.content',
        defaultMessage: 'Benefits rollout with the goal of improving employee satisfaction',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.76.ffl.task',
        defaultMessage: 'benefits rollout',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.76.ffl.goal',
        defaultMessage: 'improving employee satisfaction',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$78bb6bf9117c9ba8 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.77.ffl.content',
        defaultMessage: 'Recruitment campaign with the goal of hiring top talent',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.77.ffl.task',
        defaultMessage: 'recruitment campaign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.77.ffl.goal',
        defaultMessage: 'hiring top talent',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$35ab0ba9aa19c048 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.78.ffl.content',
        defaultMessage: 'Employee survey with the goal of gathering feedback',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.78.ffl.task',
        defaultMessage: 'employee survey',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.78.ffl.goal',
        defaultMessage: 'gathering feedback',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a2510dd93efe31ef = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.79.ffl.content',
        defaultMessage: 'Compliance audit with the goal of meeting regulations',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.79.ffl.task',
        defaultMessage: 'compliance audit',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.79.ffl.goal',
        defaultMessage: 'meeting regulations',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$35ae46aa9cb3c54f = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.80.ffl.content',
        defaultMessage: 'Campus hiring program with the goal of recruiting new graduates',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.80.ffl.task',
        defaultMessage: 'campus hiring program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.80.ffl.goal',
        defaultMessage: 'recruiting new graduates',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$d873cca220ce6032 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.81.ffl.content',
        defaultMessage: 'Knowledge base with the goal of speeding up troubleshooting',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.81.ffl.task',
        defaultMessage: 'knowledge base',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.81.ffl.goal',
        defaultMessage: 'speeding up troubleshooting',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$c3408d7adaa661b = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.82.ffl.content',
        defaultMessage: 'Support workflow with the goal of managing requests',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.82.ffl.task',
        defaultMessage: 'support workflow',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.82.ffl.goal',
        defaultMessage: 'managing requests',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8376003f433cab7a = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.83.ffl.content',
        defaultMessage: 'Asset management project with the goal of tracking hardware',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.83.ffl.task',
        defaultMessage: 'asset management project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.83.ffl.goal',
        defaultMessage: 'tracking hardware',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$e8c57044a32c12dd = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.84.ffl.content',
        defaultMessage: 'Backup and recovery plan with the goal of protecting data',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.84.ffl.task',
        defaultMessage: 'backup and recovery plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.84.ffl.goal',
        defaultMessage: 'protecting data',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$219354e66633cab9 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.85.ffl.content',
        defaultMessage: 'Training program with the goal of reducing support requests',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.85.ffl.task',
        defaultMessage: 'training program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.85.ffl.goal',
        defaultMessage: 'reducing support requests',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$2e05d8d366fc16ef = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.86.ffl.content',
        defaultMessage: 'Vendor procurement project with the goal of managing suppliers',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.86.ffl.task',
        defaultMessage: 'vendor procurement project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.86.ffl.goal',
        defaultMessage: 'managing suppliers',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$f82da0359a5d86b = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.87.ffl.content',
        defaultMessage: 'System upgrade with the goal of improving reliability',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.87.ffl.task',
        defaultMessage: 'system upgrade',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.87.ffl.goal',
        defaultMessage: 'improving reliability',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ac718d2313dc759b = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.88.ffl.content',
        defaultMessage: 'Dashboard with the goal of tracking system performance',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.88.ffl.task',
        defaultMessage: 'dashboard',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.88.ffl.goal',
        defaultMessage: 'tracking system performance',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$df6110169c836468 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.89.ffl.content',
        defaultMessage: 'Process update initiative with the goal of optimizing workflows',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.89.ffl.task',
        defaultMessage: 'process update initiative',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.89.ffl.goal',
        defaultMessage: 'optimizing workflows',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a7287c8dd13a5aea = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.90.ffl.content',
        defaultMessage: 'Dashboard with the goal of providing actionable insights',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.90.ffl.task',
        defaultMessage: 'dashboard',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.90.ffl.goal',
        defaultMessage: 'providing actionable insights',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a611f3e4d87fb273 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.91.ffl.content',
        defaultMessage: 'Inventory overhaul with the goal of improving stock management',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.91.ffl.task',
        defaultMessage: 'inventory overhaul',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.91.ffl.goal',
        defaultMessage: 'improving stock management',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8334b28c2d4fc9d9 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.92.ffl.content',
        defaultMessage: 'Workflow update with the goal of improving team collaboration',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.92.ffl.task',
        defaultMessage: 'workflow update',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.92.ffl.goal',
        defaultMessage: 'improving team collaboration',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$24a7a9835dd5371e = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.93.ffl.content',
        defaultMessage: 'Vendor onboarding program with the goal of streamlining suppliers',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.93.ffl.task',
        defaultMessage: 'vendor onboarding program',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.93.ffl.goal',
        defaultMessage: 'streamlining suppliers',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$e9aed7ccbc11b019 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.94.ffl.content',
        defaultMessage: 'Logistics plan with the goal of ensuring smooth operations',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.94.ffl.task',
        defaultMessage: 'logistics plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.94.ffl.goal',
        defaultMessage: 'ensuring smooth operations',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$314e0f69ccc1d38a = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.95.ffl.content',
        defaultMessage: 'Budget plan with the goal of controlling costs',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.95.ffl.task',
        defaultMessage: 'budget plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.95.ffl.goal',
        defaultMessage: 'controlling costs',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$1e537e1670815d80 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.96.ffl.content',
        defaultMessage: 'Process optimization project with the goal of reducing bottlenecks',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.96.ffl.task',
        defaultMessage: 'process optimization project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.96.ffl.goal',
        defaultMessage: 'reducing bottlenecks',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$bda370311792820b = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.97.ffl.content',
        defaultMessage: 'Product feature with the goal of improving the user experience',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.97.ffl.task',
        defaultMessage: 'product feature',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.97.ffl.goal',
        defaultMessage: 'improving the user experience',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9e431b0aa66e8252 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.98.ffl.content',
        defaultMessage: 'Design system with the goal of scaling consistent components',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.98.ffl.task',
        defaultMessage: 'design system',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.98.ffl.goal',
        defaultMessage: 'scaling consistent components',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$4b2bd99114944c59 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.99.ffl.content',
        defaultMessage: 'Website redesign with the goal of simplifying navigation',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.99.ffl.task',
        defaultMessage: 'website redesign',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.99.ffl.goal',
        defaultMessage: 'simplifying navigation',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a41c7817b9e4797e = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.100.ffl.content',
        defaultMessage: 'Brand refresh with the goal of unifying visuals',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.100.ffl.task',
        defaultMessage: 'brand refresh',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.100.ffl.goal',
        defaultMessage: 'unifying visuals',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$c8d0d05503dbe79a = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.101.ffl.content',
        defaultMessage: 'Interactive prototype with the goal of testing new concepts',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.101.ffl.task',
        defaultMessage: 'interactive prototype',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.101.ffl.goal',
        defaultMessage: 'testing new concepts',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a240bee4318a7275 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.102.ffl.content',
        defaultMessage: 'Research study with the goal of validating design decisions',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.102.ffl.task',
        defaultMessage: 'research study',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.102.ffl.goal',
        defaultMessage: 'validating design decisions',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$21a95300c10295cb = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.103.ffl.content',
        defaultMessage: 'Content strategy with the goal of creating a consistent voice',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.103.ffl.task',
        defaultMessage: 'content strategy',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.103.ffl.goal',
        defaultMessage: 'creating a consistent voice',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$cfa4185509d4a774 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.104.ffl.content',
        defaultMessage: 'Mobile app design with the goal of streamlining core user flows',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.104.ffl.task',
        defaultMessage: 'mobile app design',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.104.ffl.goal',
        defaultMessage: 'streamlining core user flows',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$ed7df379a72deca9 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.105.ffl.content',
        defaultMessage: 'Product release with the goal of keeping teams aligned',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.105.ffl.task',
        defaultMessage: 'product release',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.105.ffl.goal',
        defaultMessage: 'keeping teams aligned',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$a238aef13a297f47 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.106.ffl.content',
        defaultMessage: 'A new product with the goal of increasing revenue',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.106.ffl.task',
        defaultMessage: 'a new product',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.106.ffl.goal',
        defaultMessage: 'increasing revenue',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$4c943dbf592d3daf = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.107.ffl.content',
        defaultMessage: 'Marketing launch with the goal of ensuring on-time delivery',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.107.ffl.task',
        defaultMessage: 'marketing launch',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.107.ffl.goal',
        defaultMessage: 'ensuring on-time delivery',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8ea24421c21eb989 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.108.ffl.content',
        defaultMessage: 'Resource plan with the goal of balancing workloads',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.108.ffl.task',
        defaultMessage: 'resource plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.108.ffl.goal',
        defaultMessage: 'balancing workloads',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$9060f613b4033371 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.109.ffl.content',
        defaultMessage: 'Status report with the goal of keeping leadership informed',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.109.ffl.task',
        defaultMessage: 'status report',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.109.ffl.goal',
        defaultMessage: 'keeping leadership informed',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$3b9fc7e351d5a0da = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.110.ffl.content',
        defaultMessage: 'Timeline plan with the goal of meeting deadlines',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.110.ffl.task',
        defaultMessage: 'timeline plan',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.110.ffl.goal',
        defaultMessage: 'meeting deadlines',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$8558a67dfa2e822a = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.111.ffl.content',
        defaultMessage: 'Risk assessment with the goal of reducing project blockers',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.111.ffl.task',
        defaultMessage: 'risk assessment',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.111.ffl.goal',
        defaultMessage: 'reducing project blockers',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$91724e490013331 = (0, $fnHPc.defineMessages)({
    content: {
        id: 'suggestion.112.ffl.content',
        defaultMessage: 'Cross-functional project with the goal of coordinating team tasks',
        description: 'The content for the suggestion'
    },
    task: {
        id: 'suggestion.112.ffl.task',
        defaultMessage: 'cross-functional project',
        description: 'The task for the suggestion'
    },
    goal: {
        id: 'suggestion.112.ffl.goal',
        defaultMessage: 'coordinating team tasks',
        description: 'The goal for the suggestion'
    }
});
const $96f168e338d9fe03$export$1699afe393f55639 = (teamType)=>{
    switch(teamType){
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return [
                $96f168e338d9fe03$export$3e3e8e3ace2d7f0e,
                $96f168e338d9fe03$export$4083d838b33ee248,
                $96f168e338d9fe03$export$238954bdf622c599,
                $96f168e338d9fe03$export$e67cd156d6d6f2ae,
                $96f168e338d9fe03$export$c859d4b806b7c319,
                $96f168e338d9fe03$export$aa93c7dd62258c4c,
                $96f168e338d9fe03$export$5eb899ea0abf885b,
                $96f168e338d9fe03$export$fffcfc2b88cf5096,
                $96f168e338d9fe03$export$9fe450f0fded883a,
                $96f168e338d9fe03$export$ec5ddcbed75bc531
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return [
                $96f168e338d9fe03$export$d946a96bae566935,
                $96f168e338d9fe03$export$7c01f95ee53b1178,
                $96f168e338d9fe03$export$2f763ba3e5452cc1,
                $96f168e338d9fe03$export$1397ef1e776ed951,
                $96f168e338d9fe03$export$8cad710146c3f103,
                $96f168e338d9fe03$export$51ac07ea9a8753b7,
                $96f168e338d9fe03$export$aa3333d2f7d341a9,
                $96f168e338d9fe03$export$ba89ed94fac4b472
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return [
                $96f168e338d9fe03$export$700e64e0f0dceb08,
                $96f168e338d9fe03$export$50293e2ec360ad90,
                $96f168e338d9fe03$export$2c612aa5d867d94d,
                $96f168e338d9fe03$export$75d56ecc14891dc1,
                $96f168e338d9fe03$export$10d5913842e26806,
                $96f168e338d9fe03$export$e32f3ee079464889,
                $96f168e338d9fe03$export$3c2846799041acd1,
                $96f168e338d9fe03$export$28f387abcb0b61c2
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
            return [
                $96f168e338d9fe03$export$217ea0fee69755b2,
                $96f168e338d9fe03$export$ba7d0398d02cd9c0,
                $96f168e338d9fe03$export$510943abc3818b56,
                $96f168e338d9fe03$export$eb28136e581b59a2,
                $96f168e338d9fe03$export$fb13f40a79e19ca5,
                $96f168e338d9fe03$export$443d3648968f7329,
                $96f168e338d9fe03$export$b47a1b25f95c27f7,
                $96f168e338d9fe03$export$ff468a2badd833da
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return [
                $96f168e338d9fe03$export$5a07aeb3f31820fd,
                $96f168e338d9fe03$export$dfd30a31c0976d81,
                $96f168e338d9fe03$export$95dbb3526f288923,
                $96f168e338d9fe03$export$70448386f1965d8f,
                $96f168e338d9fe03$export$9b985ff42826fe70,
                $96f168e338d9fe03$export$90db3bc5ac7e2675,
                $96f168e338d9fe03$export$cacf7e1270784764,
                $96f168e338d9fe03$export$73dab2578d6196e
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SALES:
            return [
                $96f168e338d9fe03$export$e89b21d7e4f,
                $96f168e338d9fe03$export$7552cab841864320,
                $96f168e338d9fe03$export$7a24837b79d45438,
                $96f168e338d9fe03$export$8b9f0dc25b70b492,
                $96f168e338d9fe03$export$6aaa62a0350d7e26,
                $96f168e338d9fe03$export$2998d96008544a57,
                $96f168e338d9fe03$export$9f50b52f7978030,
                $96f168e338d9fe03$export$233be78d085cc677
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return [
                $96f168e338d9fe03$export$9a70a449effffd31,
                $96f168e338d9fe03$export$b42e1c0dd11c43a8,
                $96f168e338d9fe03$export$c75ce3d04975da18,
                $96f168e338d9fe03$export$7d4e88dfaf5cfbf2,
                $96f168e338d9fe03$export$edc324362fedbd80,
                $96f168e338d9fe03$export$fe3389126f5cb0d8,
                $96f168e338d9fe03$export$dd6b1ebf96801fbc,
                $96f168e338d9fe03$export$4d5e8549a481dc8f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return [
                $96f168e338d9fe03$export$93f014d48a475135,
                $96f168e338d9fe03$export$d11bd1cb56453b28,
                $96f168e338d9fe03$export$4c3a6919fce6fd40,
                $96f168e338d9fe03$export$c439b80ed7353230,
                $96f168e338d9fe03$export$ea984107697503fc,
                $96f168e338d9fe03$export$28e7793f76656931,
                $96f168e338d9fe03$export$1da97b56a73dc2b2,
                $96f168e338d9fe03$export$ced6c8fb350e76bb
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return [
                $96f168e338d9fe03$export$a4bf996d2c840321,
                $96f168e338d9fe03$export$673f161eccda0fd2,
                $96f168e338d9fe03$export$16b6eaa2913019eb,
                $96f168e338d9fe03$export$747e538403f25754,
                $96f168e338d9fe03$export$131cdd783f6832db,
                $96f168e338d9fe03$export$b39996d55eda2c57,
                $96f168e338d9fe03$export$db220d81a1a51dbb,
                $96f168e338d9fe03$export$22b3d354cda23d40
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_HR:
            return [
                $96f168e338d9fe03$export$116ac96c94b3d638,
                $96f168e338d9fe03$export$a2ffbc021439bdbd,
                $96f168e338d9fe03$export$de23ac620cd66202,
                $96f168e338d9fe03$export$22b19d3e0decb8c0,
                $96f168e338d9fe03$export$78bb6bf9117c9ba8,
                $96f168e338d9fe03$export$35ab0ba9aa19c048,
                $96f168e338d9fe03$export$a2510dd93efe31ef,
                $96f168e338d9fe03$export$35ae46aa9cb3c54f
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return [
                $96f168e338d9fe03$export$d873cca220ce6032,
                $96f168e338d9fe03$export$c3408d7adaa661b,
                $96f168e338d9fe03$export$8376003f433cab7a,
                $96f168e338d9fe03$export$e8c57044a32c12dd,
                $96f168e338d9fe03$export$219354e66633cab9,
                $96f168e338d9fe03$export$2e05d8d366fc16ef,
                $96f168e338d9fe03$export$f82da0359a5d86b,
                $96f168e338d9fe03$export$ac718d2313dc759b
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return [
                $96f168e338d9fe03$export$df6110169c836468,
                $96f168e338d9fe03$export$a7287c8dd13a5aea,
                $96f168e338d9fe03$export$a611f3e4d87fb273,
                $96f168e338d9fe03$export$8334b28c2d4fc9d9,
                $96f168e338d9fe03$export$24a7a9835dd5371e,
                $96f168e338d9fe03$export$e9aed7ccbc11b019,
                $96f168e338d9fe03$export$314e0f69ccc1d38a,
                $96f168e338d9fe03$export$1e537e1670815d80
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return [
                $96f168e338d9fe03$export$bda370311792820b,
                $96f168e338d9fe03$export$9e431b0aa66e8252,
                $96f168e338d9fe03$export$4b2bd99114944c59,
                $96f168e338d9fe03$export$a41c7817b9e4797e,
                $96f168e338d9fe03$export$c8d0d05503dbe79a,
                $96f168e338d9fe03$export$a240bee4318a7275,
                $96f168e338d9fe03$export$21a95300c10295cb,
                $96f168e338d9fe03$export$cfa4185509d4a774
            ];
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return [
                $96f168e338d9fe03$export$ed7df379a72deca9,
                $96f168e338d9fe03$export$a238aef13a297f47,
                $96f168e338d9fe03$export$4c943dbf592d3daf,
                $96f168e338d9fe03$export$8ea24421c21eb989,
                $96f168e338d9fe03$export$9060f613b4033371,
                $96f168e338d9fe03$export$3b9fc7e351d5a0da,
                $96f168e338d9fe03$export$8558a67dfa2e822a,
                $96f168e338d9fe03$export$91724e490013331
            ];
        default:
            return [];
    }
};

});

parcelRegister("6qhMT", function(module, exports) {
$parcel$export(module.exports, "PAID_JIRA_AI_FLOW", function () { return $f5661b1f1d377ec0$export$15580d5934f13398; });
$parcel$export(module.exports, "PAID_JIRA_AI_EXPERIMENT_KEY", function () { return $f5661b1f1d377ec0$export$cece5c76676ec0b; });
$parcel$export(module.exports, "categorizeTeamType", function () { return $f5661b1f1d377ec0$export$1029d82c7dcd7984; });
$parcel$export(module.exports, "getCgsKeyFromLocationHref", function () { return $f5661b1f1d377ec0$export$22103f8d80cc8961; });
$parcel$export(module.exports, "derivePromptType", function () { return $f5661b1f1d377ec0$export$c37691d1fa2eace6; });
$parcel$export(module.exports, "firePaidJiraAiEvent", function () { return $f5661b1f1d377ec0$export$9a72bee4029287c2; });
$parcel$export(module.exports, "safeErrorContext", function () { return $f5661b1f1d377ec0$export$b800576c577b2197; });
const $f5661b1f1d377ec0$export$15580d5934f13398 = 'paidLandingJiraAi';
const $f5661b1f1d377ec0$export$cece5c76676ec0b = 'cfind6469FrictionlessFirstLookJiraV3';
function $f5661b1f1d377ec0$export$1029d82c7dcd7984(teamType) {
    // Keep this stable and explicit so analysis is consistent.
    switch(teamType){
        case 'software-development':
        case 'it-support':
            return 'tech';
        case 'product-management':
        case 'marketing':
        case 'project-management':
        case 'design':
            return 'biz';
        default:
            return 'unknown';
    }
}
function $f5661b1f1d377ec0$export$22103f8d80cc8961(href) {
    try {
        const url = new URL(href);
        return url.searchParams.get('cgsKey') ?? undefined;
    } catch  {
        return undefined;
    }
}
function $f5661b1f1d377ec0$export$c37691d1fa2eace6(args) {
    const workingOnIsCustom = Boolean(args.workingOnValue?.trim());
    const goalIsCustom = Boolean(args.goalValue?.trim());
    if (workingOnIsCustom && goalIsCustom) return 'custom';
    if (!workingOnIsCustom && !goalIsCustom) return 'template';
    return 'mixed';
}
function $f5661b1f1d377ec0$export$9a72bee4029287c2(createAnalyticsEvent, payload) {
    createAnalyticsEvent({
        eventType: payload.eventType ?? 'track',
        action: payload.action,
        actionSubject: 'paidLandingJiraAiExperiment',
        attributes: {
            ...payload.attributes,
            step: payload.step
        }
    }).fire();
}
function $f5661b1f1d377ec0$export$b800576c577b2197(error) {
    if (error instanceof Error) {
        const msg = error.message || '';
        if (msg.includes('Missing reCAPTCHA')) return {
            errorType: 'recaptcha_missing',
            errorName: error.name,
            message: msg
        };
        return {
            errorType: 'unknown',
            errorName: error.name,
            message: msg,
            status: error?.response?.status
        };
    }
    // Support UnsuccessfulFetchError-like shapes without importing cross-package types.
    if (error && typeof error === 'object') {
        const maybeStatus = error.status;
        if (typeof maybeStatus === 'number') return {
            errorType: 'http_error',
            status: maybeStatus
        };
    }
    return {
        errorType: 'unknown'
    };
}

});



parcelRegister("9yej4", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $10c225bc5d730156$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $10c225bc5d730156$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    heroHeading: {
        id: 'PaidLanding.JiraAIv2.heroHeading',
        defaultMessage: `People+AI get it \u{201C}Done\u{201D} faster`,
        description: 'Page hero heading on the Jira frictionless first look v2 landing page.'
    },
    heroSubheading: {
        id: 'PaidLanding.JiraAIv2.heroSubheading',
        defaultMessage: 'Team up with AI agents to orchestrate, plan, and track projects at scale.',
        description: 'Page hero subheading on the Jira frictionless first look v2 landing page.'
    },
    promptBoxHeading: {
        id: 'PaidLanding.JiraAIv2.promptBoxHeading',
        defaultMessage: 'Generate your Jira plan with AI',
        description: 'Heading shown above the Jira AI mad-lib prompt box.'
    },
    workEmailLabel: {
        id: 'PaidLanding.JiraAIv2.workEmailLabel',
        defaultMessage: 'Work email',
        description: 'Label above the work email input in the embedded signup form.'
    },
    tryItOut: {
        id: 'PaidLanding.JiraAIv2.madLibPrompt.tryItOut',
        defaultMessage: 'Generate Jira plan',
        description: 'Button text to submit mad-lib in v2 layouts'
    }
});

});

parcelRegister("7T1at", function(module, exports) {
$parcel$export(module.exports, "paidJiraAiBackgroundV2SlideMs", function () { return $255c9424460bde02$export$1c8523bba720c0e6; });
/* paid-jira-ai-background-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ // Pre-click: gradient stays at the original 480px container height (responsive
// to viewport width via 100% width). Post-click: height scales dynamically with
// the measured inline preview content (see PaidJiraAiBackgroundV2 props).
// Breathing room (px) between the bottom of the results table and the
// gradient's bottom edge.

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $255c9424460bde02$var$RESULTS_BREATHING_ROOM_PX = 24;
// The container starts TOP_OVERHANG_PX above the prompt container,
// so total gradient height = overhang + (distance from prompt-top to preview-bottom) + breathing room.
const $255c9424460bde02$var$TOP_OVERHANG_PX = 100;
const $255c9424460bde02$export$1c8523bba720c0e6 = 600;
const $255c9424460bde02$var$containerStyle = null;
const $255c9424460bde02$var$gradientBandStyle = null;
const $255c9424460bde02$var$leftVectorStyle = null;
const $255c9424460bde02$var$leftVectorHiddenStyle = null;
const $255c9424460bde02$var$leftTicketsStyle = null;
const $255c9424460bde02$var$rightVectorStyle = null;
const $255c9424460bde02$var$rightVectorHiddenStyle = null;
const $255c9424460bde02$var$rightGoalsStyle = null;
const $255c9424460bde02$export$d4d074285da57655 = ({ shouldSlideOut: shouldSlideOut = false, expandedHeight: expandedHeight })=>{
    // expandedHeight is the distance from the top of the prompt container down
    // to the bottom of the inline preview (measured by the parent). The gradient
    // container starts TOP_OVERHANG_PX above the prompt container, so total
    // height = overhang + that distance + small breathing room.
    // Add a 15% buffer past the measured content so the gradient extends just
    // beyond the bottom of the results table.
    const dynamicHeight = expandedHeight !== undefined ? $255c9424460bde02$var$TOP_OVERHANG_PX + expandedHeight * 1.15 + $255c9424460bde02$var$RESULTS_BREATHING_ROOM_PX : undefined;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        style: dynamicHeight ? {
            height: dynamicHeight
        } : undefined,
        "data-testid": "paid-jira-ai-background",
        className: (0, $2jatx.default)([
            "_1pbyidpf _kqswstnw _152tp1rm _1e021ssb _t9eczr6s _1bsb1osq _4t3i1y37 _lcxvglyw _1reoewfl _18m9ewfl _v5641ph3"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1osq _kqswstnw _1e02idpf _152tidpf _11q71gld _tzy4sxj9 _mkrz1plw"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _152tnagk _tzy4kb7n _t9ecz12g _v5645560 _spvdglyw",
                    shouldSlideOut && "_t9ec18n8 _tzy4idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "278",
                        height: "346",
                        viewBox: "0 0 278 346",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M126.304 216.886C141.869 233.09 165.768 229.102 199.031 197.151C202.628 193.696 205.438 189.284 209.035 185.829L277.314 256.912C271.899 263.892 263.781 271.69 252.99 282.056C170.191 361.588 93.474 360.919 42.4374 307.786C4.43138 268.22 0.727808 230.217 3.22073 191.465C3.82247 163.224 5.10354 142.958 -8.71683 128.57C-24.2812 112.367 -48.1115 116.288 -81.4433 148.306L-93.0907 159.494L-160.514 89.3015C-154.209 81.4664 -146.09 73.6677 -136.19 64.1579C-52.5348 -16.1976 23.3597 -16.3841 75.219 37.6046C113.258 77.2054 116.038 116.03 114.333 154.025C113.8 182.2 112.45 202.531 126.27 216.919L126.304 216.886Z",
                            fill: "#FCA700"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02idpf _152t1ame _1itk1wg8 _1lrw1dfr _12vemgnk _1bsb1l5f _4t3i1g4h _1pbycs5v"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _rjxpidpf _152t1nuc _tzy4kb7n _t9ecz12g _v5645560 _spvdglyw",
                    shouldSlideOut && "_t9ecd6nh _tzy4idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        width: "259",
                        height: "422",
                        viewBox: "0 0 259 422",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M387.189 211.854L214.396 384.134L111.034 351.343L69.1056 110.944L261.572 55.9512L387.189 211.854Z",
                            fill: "#BF63F3",
                            stroke: "#BF63F3",
                            strokeWidth: "6"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _rjxpidpf _152tautk _1itk1t7m _1lrw1dfr _12vemgnk _1bsb3sup _4t3io25y _1pbycs5v"
                        ])
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gVbYe", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiHeaderV2", function () { return $f6aaf66210230a3a$export$e5ae58f680b7cb1a; });
/* paid-jira-ai-header-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $6KUQg = parcelRequire("6KUQg");

var $32ARy = parcelRequire("32ARy");

var $kbpa7 = parcelRequire("kbpa7");

var $9yej4 = parcelRequire("9yej4");
const $f6aaf66210230a3a$var$containerCss = null;
const $f6aaf66210230a3a$var$copyCss = null;
const $f6aaf66210230a3a$var$headingCss = null;
const $f6aaf66210230a3a$var$headingAccentCss = null;
const $f6aaf66210230a3a$var$subheadingCss = null;
const $f6aaf66210230a3a$var$formCardCss = null;
const $f6aaf66210230a3a$export$e5ae58f680b7cb1a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "data-testid": "paid-jira-ai-header-v2",
        "aria-labelledby": "paid-jira-ai-header-v2-heading",
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0ehkll _zulpckbl _4cvr1h6o _1bsb1osq _p12ftfvk _195g1wug _vchhusvi _18zr1tcg _1q51ckbl _85i51tcg _1rqt1lmi _xc2izwfg _144tidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulp7vkz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        id: "paid-jira-ai-header-v2-heading",
                        className: (0, $2jatx.default)([
                            "_k48p9y44 _1wybckbl _vwz48vuz _syaz1pfd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _3p1cckbl _1cqs8pqr"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $9yej4.messages).heroHeading,
                            values: {
                                accent: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syaz5hrz"
                                        ]),
                                        style: {
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                        },
                                        children: chunks
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_k48p1nn1 _1wyb7vkz _vwz4yu22 _syaz1pfd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1414 _1cqs1j6v"
                        ]),
                        style: {
                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            ...(0, $9yej4.messages).heroSubheading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _ndwch9n0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6KUQg.AccountCreation), {
                    Login: null,
                    Social: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {
                        providers: {
                            google: 'Google'
                        }
                    })
                })
            })
        ]
    });

});

parcelRegister("jYNiT", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiDisclaimer", function () { return $ae803050897374c7$export$360a68ea5c3472a9; });
/* paid-jira-ai-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $kYjgt = parcelRequire("kYjgt");
const $ae803050897374c7$var$containerCss = null;
const $ae803050897374c7$export$360a68ea5c3472a9 = ()=>{
    const acceptableUsePolicyLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/acceptable-use-policy');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1wyboqnp _vwz41cby _1pfh1j6v _6rth53f4 _y3gn1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...(0, $kYjgt.messages).acceptableUsePolicyDisclaimer,
            values: {
                acceptableUsePolicyLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        type: "inline",
                        text: text,
                        "aria-label": text,
                        href: acceptableUsePolicyLinkHref
                    })
            }
        })
    });
};

});

parcelRegister("33kEK", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiTeamTypeMadLibPrompt", function () { return $cd6c6dd32e2ad127$export$df93ffe29d467f53; });
/* paid-jira-ai-team-type-mad-lib-prompt.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $7Sqn0 = parcelRequire("7Sqn0");
var $ddxTX = parcelRequire("ddxTX");

var $4se1R = parcelRequire("4se1R");

var $ahmPu = parcelRequire("ahmPu");

var $9yC2v = parcelRequire("9yC2v");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");

var $jUBSR = parcelRequire("jUBSR");

var $fx9D8 = parcelRequire("fx9D8");

var $l7lZe = parcelRequire("l7lZe");
const $cd6c6dd32e2ad127$var$modalCss = null;
const $cd6c6dd32e2ad127$var$teamTypeContainerCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonsGroupCss = null;
const $cd6c6dd32e2ad127$var$teamTypeButtonStyles = {
    fontWeight: 400,
    borderRadius: 8,
    marginInlineStart: 4,
    marginBlockEnd: 4
};
const $cd6c6dd32e2ad127$var$footerCss = null;
const $cd6c6dd32e2ad127$var$disclaimerCss = null;
const $cd6c6dd32e2ad127$var$poweredByAiCss = null;
const $cd6c6dd32e2ad127$var$shuffleButtonStyles = {
    borderRadius: '40px',
    paddingLeft: '4px',
    paddingRight: '4px',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 400,
    alignItems: 'center'
};
const $cd6c6dd32e2ad127$var$actionButtonStyles = {
    borderRadius: '40px',
    paddingLeft: '24px',
    paddingRight: '24px',
    fontSize: '16px',
    lineHeight: '20px',
    alignItems: 'center'
};
const $cd6c6dd32e2ad127$export$df93ffe29d467f53 = ({ isRerun: isRerun, showLoadingState: showLoadingState, ctaMessage: ctaMessage, ctaKey: ctaKey })=>{
    const { submit: submit, cgsDataLoading: cgsDataLoading, selectedTeamType: selectedTeamType, setSelectedTeamType: setSelectedTeamType, workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, setWorkingOnValue: setWorkingOnValue, setGoalValue: setGoalValue, setHasUserSelectedTeamType: setHasUserSelectedTeamType, hasUserSelectedTeamType: hasUserSelectedTeamType, shuffle: shuffle, suggestMadLib: suggestMadLib, setIsErrorFromCgs: setIsErrorFromCgs, firePaidJiraAi: firePaidJiraAi, markPromptChangedField: markPromptChangedField, commonAnalyticsAttributes: commonAnalyticsAttributes, promptAttemptIndex: promptAttemptIndex } = (0, $jUBSR.useJiraAiFFL)();
    const [isFormValid, setIsFormValid] = (0, $1oC0p.useState)(true);
    const submitCtaMessage = ctaMessage ?? (0, $kYjgt.messages).getStarted;
    const handleOnSubmit = async ()=>{
        if (!isFormValid) return;
        // Track click intent separately from the async lifecycle events in the context.
        firePaidJiraAi('BuildWithAIClicked', 'clicked', {
            cta: isRerun ? 'rerunPrompt' : ctaKey ?? 'getStarted',
            promptAttemptIndex: promptAttemptIndex + 1
        });
        const params = {
            teamType: selectedTeamType,
            workingOnValue: workingOnValue || workingOnSuggestion,
            goalValue: goalValue || goalSuggestion
        };
        await submit({
            teamType: params.teamType,
            workingOn: params.workingOnValue,
            goal: params.goalValue
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1o8l _1bsb1osq _p12f1osq _16qs1kzk _2rko7vkz _11q71afi _ca0q1tcg _u5f3gktf _n3td1tcg _19bvgktf _y3gn1e5h"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: [
            !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rth7vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbqmyb0 _6rthmyb0"
                    ]),
                    children: Object.entries((0, $fx9D8.teamTypesMap)).map(([teamType, { messageKey: messageKey }])=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            appearance: selectedTeamType === teamType ? 'subtle' : 'default',
                            isSelected: selectedTeamType === teamType,
                            style: $cd6c6dd32e2ad127$var$teamTypeButtonStyles,
                            onClick: ()=>{
                                markPromptChangedField('teamType');
                                firePaidJiraAi('PromptTeamTypeSelected', 'clicked', {
                                    previousTeamType: selectedTeamType,
                                    newTeamType: teamType,
                                    isFirstSelection: !hasUserSelectedTeamType
                                });
                                setHasUserSelectedTeamType(true);
                                setSelectedTeamType(teamType);
                                suggestMadLib(teamType);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $kYjgt.messages)[messageKey]
                            })
                        }, teamType))
                })
            }) : null,
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7lZe.PaidJiraAiMadLib), {
                focusInput: !isRerun,
                workingOnSuggestion: workingOnSuggestion,
                goalSuggestion: goalSuggestion,
                workingOnValue: workingOnValue,
                goalValue: goalValue,
                onEnter: handleOnSubmit,
                onChange: ({ workingOnValue: newWorkingOnValue, goalValue: newGoalValue })=>{
                    if (newWorkingOnValue !== workingOnValue) {
                        setIsErrorFromCgs(false);
                        setWorkingOnValue(newWorkingOnValue);
                        if (!commonAnalyticsAttributes.changedFields?.includes('workingOn')) firePaidJiraAi('PromptFieldChanged', 'clicked', {
                            field: 'workingOn',
                            valueLength: newWorkingOnValue.trim().length,
                            isCustom: Boolean(newWorkingOnValue.trim())
                        });
                        markPromptChangedField('workingOn');
                    }
                    if (newGoalValue !== goalValue) {
                        setIsErrorFromCgs(false);
                        setGoalValue(newGoalValue);
                        if (!commonAnalyticsAttributes.changedFields?.includes('goal')) firePaidJiraAi('PromptFieldChanged', 'clicked', {
                            field: 'goal',
                            valueLength: newGoalValue.trim().length,
                            isCustom: Boolean(newGoalValue.trim())
                        });
                        markPromptChangedField('goal');
                    }
                },
                setAreInputsValid: setIsFormValid
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1pfh7vkz _1e0c1txw _1bah1yb4 _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect4b1j9 _1wyb1crf _vwz47vkz _syaz1ggn"
                        ]),
                        children: !isRerun ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _zulp1y44"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    ...(0, $kYjgt.messages).poweredByAi
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4se1R))), {
                                    label: "Status info"
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7Sqn0.default), {
                        children: cgsDataLoading || showLoadingState ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                            isDisabled: true,
                            appearance: "subtle",
                            style: $cd6c6dd32e2ad127$var$actionButtonStyles,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                ...(0, $kYjgt.messages).working
                            })
                        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "subtle",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9yC2v))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$shuffleButtonStyles,
                                    onClick: shuffle,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $kYjgt.messages).shuffle
                                    })
                                }),
                                isRerun ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "primary",
                                    iconBefore: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                                        label: ""
                                    }),
                                    style: $cd6c6dd32e2ad127$var$actionButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...(0, $kYjgt.messages).rerunPrompt
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    isDisabled: !isFormValid,
                                    appearance: "primary",
                                    style: $cd6c6dd32e2ad127$var$actionButtonStyles,
                                    onClick: handleOnSubmit,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        ...submitCtaMessage
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7Sqn0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5bc20816e4beb8e1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $5bc20816e4beb8e1$var$buttonGroupStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> *': {
        flex: '1 0 auto'
    }
});
function $5bc20816e4beb8e1$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $5bc20816e4beb8e1$var$buttonGroupStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("l7lZe", function(module, exports) {
$parcel$export(module.exports, "PaidJiraAiMadLib", function () { return $d5f42ac48b84f3d9$export$c896215e2accffb4; });
/* paid-jira-ai-mad-lib.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $grHEz = parcelRequire("grHEz");

var $kbpa7 = parcelRequire("kbpa7");

var $kYjgt = parcelRequire("kYjgt");
const $d5f42ac48b84f3d9$var$containerStyle = null;
const $d5f42ac48b84f3d9$var$inlineInputStyle = null;
const $d5f42ac48b84f3d9$var$MadLibLabel = ({ id: id, str: str, forSelector: forSelector })=>{
    const focusInput = ()=>{
        const element = window.document.querySelector(forSelector);
        element?.focus();
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            focusInput();
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        id: id,
        onClick: focusInput,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        children: str
    });
};
const $d5f42ac48b84f3d9$export$c896215e2accffb4 = ({ workingOnSuggestion: workingOnSuggestion, goalSuggestion: goalSuggestion, workingOnValue: workingOnValue, goalValue: goalValue, onChange: onChange, onEnter: onEnter, focusInput: focusInput, setAreInputsValid: setAreInputsValid })=>{
    const [isWorkingOnInputValid, setIsWorkingOnInputValid] = (0, $1oC0p.useState)(true);
    const [isGoalInputValid, setIsGoalInputValid] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        setAreInputsValid?.(isWorkingOnInputValid && isGoalInputValid);
    }, [
        setAreInputsValid,
        isWorkingOnInputValid,
        isGoalInputValid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ect41vau _1wyb1tcg _vwz41ylp _1dyznl7k _syazlkxj _1tke1lev"
        ]),
        style: {
            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
            "--_1px5u0o": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light1000'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            ...(0, $kYjgt.messages).madLib,
            values: {
                workingOn: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "workingOnLabel",
                        str: str,
                        forSelector: "#working-on-input span[contenteditable]"
                    }),
                goal: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d5f42ac48b84f3d9$var$MadLibLabel, {
                        id: "goalLabel",
                        str: str,
                        forSelector: "#goal-input span[contenteditable]"
                    }),
                workingOnInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "working-on-input",
                    className: (0, $2jatx.default)([
                        "_syaz5hrz _179r1p8s _5piovatn _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_gc8zf8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.purple'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: workingOnValue,
                        placeholder: workingOnSuggestion,
                        ariaLabelledBy: "workingOnLabel",
                        animatePlaceholder: true,
                        focus: focusInput,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: value,
                                goalValue: goalValue
                            });
                        },
                        setIsInputValid: setIsWorkingOnInputValid
                    })
                }),
                goalInput: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    id: "goal-input",
                    className: (0, $2jatx.default)([
                        "_syaz5hrz _179r1p8s _5piovatn _y3gn1h6o _1ul953f4 _1e0c1nu9 _1tke1u1b _vwz4d6z3 _s7n4z0dk _1kt9f705 _9tn1qvpr _aetrf705 _1qjlqvpr"
                    ]),
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_gc8zf8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.purple'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grHEz.InlineInput), {
                        value: goalValue,
                        placeholder: goalSuggestion,
                        ariaLabelledBy: "goalLabel",
                        animatePlaceholder: true,
                        onEnter: onEnter,
                        onChange: (value)=>{
                            if (onChange) onChange({
                                workingOnValue: workingOnValue,
                                goalValue: value
                            });
                        },
                        setIsInputValid: setIsGoalInputValid
                    })
                })
            }
        })
    });
};

});
parcelRegister("grHEz", function(module, exports) {
$parcel$export(module.exports, "InlineInput", function () { return $264a45a5b6f2823d$export$36d3e0619bb09209; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $264a45a5b6f2823d$var$inlineInputStyle = null;
const $264a45a5b6f2823d$export$36d3e0619bb09209 = ({ value: value, placeholder: placeholder, animatePlaceholder: animatePlaceholder = false, onChange: onChange, onEnter: onEnter, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, focus: focus, setIsInputValid: setIsInputValid })=>{
    const [isClient, setIsClient] = (0, $1oC0p.useState)(false);
    const [isFocused, setIsFocused] = (0, $1oC0p.useState)(false);
    const [doesInputContainPlaceholder, setDoesInputContainPlaceholder] = (0, $1oC0p.useState)(true);
    const [initFocused, setInitFocused] = (0, $1oC0p.useState)(false);
    const inputRef = (0, $1oC0p.useRef)(null);
    const intervalRef = (0, $1oC0p.useRef)(0);
    const previousOnChangeVal = (0, $1oC0p.useRef)(undefined);
    const previousIsInputValidVal = (0, $1oC0p.useRef)(undefined);
    const previousPlaceholder = (0, $1oC0p.useRef)('');
    const previousValue = (0, $1oC0p.useRef)(undefined);
    const handleOnChange = (doesInputContainPlaceholder)=>{
        if (!isClient || !inputRef.current) return;
        // Call onChange if value changed (user is typing)
        const value = doesInputContainPlaceholder ? '' : inputRef.current.innerText;
        if (onChange && previousOnChangeVal.current !== value) {
            previousOnChangeVal.current = value;
            onChange(value);
        }
        // Call setIsInputValid when input changes between valid/invalid (empty = invalid)
        const isValid = !!(doesInputContainPlaceholder || inputRef.current.innerText);
        if (setIsInputValid && previousIsInputValidVal.current !== isValid) {
            previousIsInputValidVal.current = isValid;
            setIsInputValid(isValid);
        }
        // Focus on input on component load
        if (focus && !initFocused) {
            inputRef.current.focus();
            // Move cursor to the end
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false); // false = to end of node
            const sel = window.getSelection();
            sel?.removeAllRanges();
            sel?.addRange(range);
            setInitFocused(true);
        }
    };
    // Handle blur: restore placeholder if empty
    const handleOnBlur = (0, $1oC0p.useCallback)(()=>{
        if (!isClient || !inputRef.current) return;
        setIsFocused(false);
        if (inputRef.current.innerText === '') {
            // Replace empty input with the placeholder text
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
        } else handleOnChange(doesInputContainPlaceholder);
    }, [
        isClient,
        placeholder,
        handleOnChange
    ]);
    // Handle input: replace placeholder on input
    const handleOnInput = (0, $1oC0p.useCallback)((e)=>{
        if (!isClient || !inputRef.current) return;
        if (doesInputContainPlaceholder) {
            const nativeEvent = e.nativeEvent;
            // Replace placeholder text with whatever the user typed
            inputRef.current.innerText = nativeEvent.data || nativeEvent.dataTransfer?.getData('text/plain') || '';
            // Set cursor to the end
            inputRef.current.focus();
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(inputRef.current);
            range.collapse(false);
            selection?.removeAllRanges();
            selection?.addRange(range);
            setDoesInputContainPlaceholder(false);
        }
        handleOnChange(false);
    }, [
        isClient,
        doesInputContainPlaceholder,
        handleOnChange
    ]);
    // Set client flag
    (0, $1oC0p.useEffect)(()=>setIsClient(true), []);
    // Animate or set placeholder
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current || value) return;
        if (previousPlaceholder.current === placeholder) return;
        previousPlaceholder.current = placeholder;
        // Set placeholder without animation
        if (!animatePlaceholder) {
            inputRef.current.innerText = placeholder;
            setDoesInputContainPlaceholder(true);
            handleOnChange(true);
            return;
        }
        // Animate placeholder
        window.clearInterval(intervalRef.current);
        inputRef.current.innerText = '';
        intervalRef.current = window.setInterval(()=>{
            if (!inputRef.current) {
                window.clearInterval(intervalRef.current);
                return;
            }
            const currentNumChars = inputRef.current.innerText.length;
            const renderNumChars = currentNumChars + (placeholder[currentNumChars] === ' ' ? 2 : 1);
            inputRef.current.innerText = placeholder.substring(0, renderNumChars);
            if (renderNumChars >= placeholder.length) {
                window.clearInterval(intervalRef.current);
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            }
        }, 35);
    }, [
        isClient,
        value,
        placeholder,
        animatePlaceholder,
        handleOnChange
    ]);
    // Sync value with input text
    (0, $1oC0p.useEffect)(()=>{
        if (!isClient || !inputRef.current) return;
        if (previousValue.current === value) return;
        previousValue.current = value;
        if (typeof value !== 'string') return;
        if (inputRef.current.innerText !== value) {
            if (value === '' && !isFocused) {
                inputRef.current.innerText = placeholder;
                setDoesInputContainPlaceholder(true);
                handleOnChange(true);
            } else {
                inputRef.current.innerText = value;
                setDoesInputContainPlaceholder(false);
                handleOnChange(false);
            }
        }
    }, [
        isClient,
        value,
        isFocused,
        placeholder,
        handleOnChange
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            !isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ]),
                children: placeholder
            }),
            isClient && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                contentEditable: "plaintext-only",
                role: "textbox",
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-placeholder": placeholder,
                tabIndex: 0,
                onInput: handleOnInput,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        onEnter?.();
                    }
                },
                onFocus: ()=>setIsFocused(true),
                onBlur: ()=>handleOnBlur(),
                ref: inputRef,
                suppressContentEditableWarning: true,
                className: (0, $2jatx.default)([
                    "_12ji1r31 _1qu2glyw _12y3idpf"
                ])
            })
        ]
    });
};

});




//# sourceMappingURL=index.9625fd5c.js.map
